import { format } from "date-fns";
import React from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
  Font,
  PDFViewer,
} from "@react-pdf/renderer";
import ReactDOMServer from "react-dom/server";
import { months } from "../../utils/getLocalDateTime";
import THBText from "thai-baht-text";
import Html from "react-pdf-html";
import fontCodia from "../../styles/CORDIA.ttf";
import NotoSansSymbols2 from "../../styles/NotoSansSymbols2-Regular.ttf";
import fontBoldCodia from "../../styles/Cordia New Bold.ttf";
import ReactToPrint from "react-to-print";

Font.register({
  family: "NotoSansSymbols2",
  fonts: [{ src: NotoSansSymbols2 }],
});

const styleFinal = StyleSheet.create({
  page: {
    fontFamily: "Sarabun",
    padding: 26,
    fontSize: 12,
    backgroundColor: "#fff",
    lineHeight: "1.5px",
  },
  txCenter: {
    textAlign: "center",
  },
  txJustify: {
    textAlign: "justify",
  },
  header: {
    textAlign: "center",
    fontWeight: "bold",
    fontSize: "16px",
  },
  topic: {
    fontWeight: "bold",
    fontSize: "12px",
  },
  p: {
    marginTop: "20px",
    textAlign: "justify",
  },
});

function GenFinalPdf({ data = [], ref }) {
  const today = new Date(data?.templateCreatedAt ?? data?.requestTime);
  const completeDate = new Date(data?.templateCreatedAt ?? data?.requestTime);
  const bankDate = new Date(data?.templateCreatedAt ?? data?.requestTime);
  const endDate = new Date(data?.templateCreatedAt ?? data?.requestTime);
  endDate.setDate(endDate.getDate() + 2);
  endDate.setMonth(endDate.getMonth() + data?.period);
  bankDate.setDate(bankDate.getDate() + 2);
  completeDate.setDate(completeDate.getDate() + 1);

  const space = "&nbsp; &nbsp;&nbsp; &nbsp;";
  const symbol = ``;
  const spaceOne = "&nbsp;";
  let type = 1;

  if (data?.purpose === "ธุรกิจ") {
    type = 3;
  }

  const getFullDate = (date, options = { showMonth: false }) => {
    return `${date.getDate()} ${options.showMonth ? "เดือน" : ""} ${
      months[date.getMonth()].monthTh
    } พ.ศ. ${date.getFullYear() + 543}`;
  };

  const getHtmlReact = () => {
    const html = getHtmlFinalPdf();
    return html;
  };

  const getHtmlFinalPdf = () => {
    const today = new Date(data?.requestTime);
    const completeDate = new Date(
      data?.completeCreateDate || data?.requestTime
    );
    const bankDate = new Date(data?.requestTime);
    const endDate = new Date(data?.requestTime);
    endDate.setDate(endDate.getDate() + 2);
    endDate.setMonth(endDate.getMonth() + data?.period);
    bankDate.setDate(bankDate.getDate() + 2);
    completeDate.setDate(completeDate.getDate() + 1);

    const symbol = ``;
    const spaceOne = "&nbsp;";
    let type = 1;

    if (data?.purpose === "ธุรกิจ") {
      type = 3;
    }

    // const space = "&nbsp; &nbsp;&nbsp; &nbsp;";
    // const htmlContent = `
    // <html lang="en">
    // <body class="body">
    // <style>
    // @font-face {
    //     font-family: 'Sarabun';
    //     font-weight: normal;
    //     font-style: normal;
    // }
    //     .body {
    //         margin: auto;
    //         width: 543px;
    //         height: 100%;
    //         font-size: 10px;
    //         color: rgb(0, 0, 0);
    //         backgroundColor:#fff;
    //         font-family: 'Sarabun', sans-serif;
    //         padding: 2px 4px;
    //     }
    //    .h2 {
    //         text-align: center;
    //         font-family: 'Sarabun';
    //         font-size: 14px;
    //     }
    //     h4 {
    //       font-size: 12px;
    //     }
    //     p, div {
    //         font-family: 'Sarabun';
    //         font-size: 12px;
    //         line-height: 1.4;
    //         display: inline-block;
    //     }
    //     .table {
    //         border-collapse: collapse;
    //         width: 100%;
    //       }

    //       .td, .th {
    //         border: 1px solid #dddddd;
    //         text-align: left;
    //         padding: 8px;
    //       }
    //       .tr:nth-child(even) {
    //         background-color: #dddddd;
    //       }
    //       .jsText {
    //         text-align: justify;
    //       }
    // </style>
    //     <h2 class="h2">สัญญาสินเชื่อ</h2>
    //     <p>${space}คำขอรับสินเชื่อและสัญญาสินเชื่อฉบับนี้ <span STYLE="font-weight:bold">(“สัญญานี้”)</span> ทำขึ้นเมื่อวันที่ ${getFullDate(
    //   today,
    //   { showMonth: true }
    // )} </p>
    //     <p>${space}โดย ${data?.article} ${data?.name} ${data?.lastname} </p>
    //     <p>ที่อยู่ ${data?.address}</p>
    //     <p>อีเมล ${data?.email}</p>
    //     <p>เบอร์โทรติดต่อ ${data?.phone_number}</p>
    //     <p>Username/login account ${data?.phone_number} </p>
    //     <p>เลขประจำตัวบัตรประชาชน ${data?.citizenid} </p>
    //     <p>อายุ ${data?.age} ปี สถานภาพ ${data?.marritalStatus} ${
    //   data?.marritalStatus == "สมรส"
    //     ? "กับ" +
    //       `${data?.articlePartner} ${data?.namePartner} ${data?.lastnamePartner}`
    //     : ""
    // }</p>
    //     <p>ซึ่งเป็นผู้ใช้แอปพลิเคชันของ บริษัท มันนี่ ฮับ เซอร์วิส จำกัด และมีชื่อปรากฎอยู่ด้านหน้าของแอปพลิเคชันดังกล่าว\n และในสัญญานี้ ในฐานะผู้กู้ (ซึ่งต่อไปในสัญญานี้จะเรียกว่า <span STYLE="font-weight:bold">“ผู้กู้”</span>)</p>
    //     <div>${space}ผู้กู้มีความประสงค์ขอสินเชื่อจาก บริษัท มันนี่ ฮับ เซอร์วิส จำกัด บริษัทจำกัดจดทะเบียนตามกฎหมายไทย${space}${space}${space}</div>
    //     <div>(ทะเบียนนิติบุคคลเลขที่ <u>0105563138266</u>) และ มีสำนักงานจดทะเบียนตั้งอยู่เลขที่ <u>1010 อาคารชินวัตรทาวเวอร์ 3 ชั้นที่ 12 ถนนวิภาวดีรังสิต แขวงจตุจักร เขตจตุจักร กรุงเทพมหานคร</u> เบอร์โทรติดต่อ 02-821-6710</div>
    //     <div>อีเมล <u>support@moneyhubservice.com</u> ในฐานะผู้ให้กู้ (ซึ่งต่อไปนี้จะเรียกว่า <span STYLE="font-weight:bold">“ผู้ให้กู้”</span>) โดยการสมัครผ่านระบบอิเล็กทรอนิกส์ของผู้ให้กู้ไม่ว่าระบบใด (ไม่ว่าจะเป็นช่องทางแอปพลิเคชันในโทรศัพท์มือถือ อินเทอร์เน็ต หรือระบบอิเล็กทรอนิกส์อื่นใดในทำนองเดียวกัน) (ซึ่งต่อไปนี้จะเรียกว่า <span STYLE="font-weight:bold">“ระบบอิเล็กทรอนิกส์”</span>) ที่ผู้ให้กู้ได้กำหนดไว้ให้ใช้ในการขอสินเชื่อตามสัญญานี้ได้ </div>

    //     <p>${space}ผู้กู้ได้อ่านและทำความเข้าใจในข้อกำหนดและเงื่อนไขทั้งปวงของสัญญานี้${space}(รวมทั้งรับทราบและตกลงในวงเงินที่ผู้ให้กู้จะอนุมัติให้) และผู้กู้สัญญาต่อผู้ให้กู้ว่า จะปฏิบัติและยินยอมผูกพันตนตามข้อกำหนดและรายละเอียดเงื่อนไขต่าง ๆ ของสัญญานี้ ข้อกำหนดและข้อตกลงเงื่อนไขต่าง ๆ ในการขอใช้บริการสินเชื่อ และเอกสารอื่นใดที่เกี่ยวข้องกับสินเชื่อที่ผู้ให้กู้จะกำหนดและให้มีผลใช้บังคับเป็นคราว ๆ ไปทุกประการ (ซึ่งต่อไปนี้จะเรียกสัญญานี้และเอกสารดังกล่าว ตลอดจนสัญญาค้ำประกันที่เป็นประกันการชำระหนี้ของผู้กู้ตามสัญญานี้และเอกสารสินเชื่ออื่น ๆ (ถ้ามี) (ตามที่อาจมีการแก้ไข เพิ่มเติม และ/หรือเปลี่ยนแปลงเป็นครั้งคราว) รวมกันว่า <span STYLE="font-weight:bold">“เอกสารสินเชื่อ”</span>) </p>
    //     <p>${space}เพื่อเป็นหลักฐานสำคัญสำหรับการรับสินเชื่อของผู้กู้จากผู้ให้กู้  ผู้กู้ตกลงต่อผู้ให้กู้ดังมีรายละเอียดต่อไปนี้</p>
    //     <br>
    //     <br>
    //     <br>
    //     <br>
    //     <br>

    //     <h3>ข้อ 1. วงเงินสินเชื่อที่ผู้ให้กู้อนุมัติ : </h3>
    //     <p>${space}ผู้กู้ตกลงกู้และขอรับสินเชื่อในรูปแบบของเงินกู้ยืม เพื่อวัตถุประสงค์ตามที่ระบุไว้ข้างล่างนี้ </p>
    //     <p>${space}${
    //   type == 1 ? "[x]" : "[ ]"
    // }${spaceOne}เพื่อการอุปโภคบริโภค / เพื่อการท่องเที่ยว</p>
    //     <p>${space}${
    //   type == 3 ? "[x]" : "[ ]"
    // }${spaceOne}เพื่อการประกอบอาชีพ</p>
    //     <p>${space}[ ]${spaceOne}ไม่ระบุวัตถุประสงค์</p>
    //     <p>โดยไม่มีทรัพย์หรือทรัพย์สินเป็นหลักประกัน และ</p>
    //     <p>${space}[x]${spaceOne}ไม่มีการค้ำประกันการชำระหนี้ของผู้กู้ </p>
    //     <p>${space}[ ]${spaceOne}มีการค้ำประกันการชำระหนี้ของผู้กู้ โดย ________________</p>
    //     <p>${space}(ซึ่งต่อไปนี้จะเรียก ผู้กู้ และ/หรือ ผู้ค้ำประกัน (ถ้ามี) แยกกันและรวมกันว่า <span STYLE="font-weight:bold">“ลูกหนี้”</span> และเรียกสินเชื่อข้างต้นว่า <span STYLE="font-weight:bold">“สินเชื่อ”</span>)</p>
    //     <p>${space}จากผู้ให้กู้ โดยขอให้วันเบิกใช้สินเชื่อเป็น วันที่ ${getFullDate(
    //   completeDate
    // )} โดยมีวงเงินกู้เป็นจำนวน ${data?.requestamount} บาท (${THBText(
    //   data?.requestamount
    // )}) ผู้กู้ตกลงและรับทราบว่าในกรณีที่ผู้ให้กู้อนุมัติการให้กู้ ผู้ให้กู้จะมีการแจ้งยืนยันการอนุมัติการให้กู้และจำนวนเงินกู้เป็นหนังสือยืนยันการอนุมัติวงเงินสินเชื่อ (ซึ่งต่อไปนี้จะเรียกว่า <span STYLE="font-weight:bold">“หนังสือยืนยัน”</span>) ให้ผู้กู้ทราบผ่านทางระบบอิเล็กทรอนิกส์ ทางโทรศัพท์ ทางไปรษณีย์อิเล็กทรอนิกส์ (E-mail) และ/หรือบอกกล่าวเป็นลายลักษณ์อักษรในรูปแบบกระดาษตามที่ผู้ให้กู้เห็นสมควร และผู้กู้ตกลงรับทราบว่าผู้ให้กู้อาจเปลี่ยนแปลงวงเงินกู้ดังกล่าวโดยแจ้งให้แก่ผู้กู้รับทราบต่อไปได้ </p>
    //     <p>${space}ทั้งนี้ ผู้ให้กู้มีสิทธิในการพิจารณาอนุมัติหรือไม่อนุมัติการให้กู้ได้ตามดุลยพินิจโดยเด็ดขาดของผู้ให้กู้ โดยผู้กู้ได้รับสัญญานี้และเอกสารสินเชื่ออื่น ๆ จากผู้ให้กู้เรียบร้อยแล้ว</p>
    //     <h3>ข้อ 2. 	เงื่อนไขการเบิกใช้สินเชื่อ :     </h3>
    //     <p>${space}2.1	ผู้กู้ตกลงขอเบิกและรับเงินสินเชื่อจากผู้ให้กู้ <span STYLE="font-weight:bold">ครั้งเดียวทั้งจำนวน</span> ในวันที่ระบุไว้ในข้อ 1 ข้างต้น โดยขอให้ผู้ให้กู้นำเงินจำนวนดังกล่าวไปเข้าบัญชีเงินฝากของผู้กู้ที่ระบุอยู่ในรายการขอสินเชื่อบนระบบอิเล็กทรอนิกส์ (ซึ่งต่อไปนี้จะเรียกว่า <span STYLE="font-weight:bold">“บัญชีรับเงินกู้”</span>) ซึ่งมีรายละเอียดบัญชีรับเงินกู้ดังนี้</p>
    //     <p>${space}${space}ชื่อบัญชี ${data?.bankAccName}</p>
    //     <p>${space}${space}เลขที่บัญชี ${data?.bankNo}</p>
    //     <p>${space}${space}ประเภทบัญชี ออมทรัพย์</p>
    //     <p>${space}${space}ธนาคาร ${data?.bank}</p>
    //     <br>
    //     <p>${space}${space}ทั้งนี้ นอกจากการเบิกใช้สินเชื่อโดยการโอนเงินเข้าบัญชีรับเงินกู้แล้ว ผู้กู้ยังสามารถเบิกใช้สินเชื่อจากผู้ให้กู้ด้วยวิธีการอื่นใดตามที่ผู้ให้กู้และผู้กู้จะตกลงกัน (ถ้ามี) ตามเงื่อนไข รูปแบบ วิธีการและรายละเอียดที่ผู้ให้กู้กำหนดและเท่าที่กฎหมายอนุญาตให้ทำได้ และเมื่อผู้ให้กู้ได้ดำเนินการดังกล่าวตามที่ตกลงกันหรือกำหนดไว้แล้ว ให้ถือว่าผู้กู้ได้รับเงินสินเชื่อจากผู้ให้กู้ครบถ้วนถูกต้องแล้ว แม้ผู้กู้จะยังไม่ได้เบิกถอนเงินจากบัญชีรับเงินกู้ หรือนำเงินที่ได้รับดังกล่าวไปใช้จ่ายก็ตาม โดยผู้กู้ไม่ต้องต้องทำหรือ ลงลายมือชื่อในเอกสารอื่นใดเพิ่มเติมเพื่อเป็นหลักฐานในการรับเงินอีก ทั้งนี้ หลังจากที่ผู้ให้กู้ส่งมอบเงินสินเชื่อให้แก่ผู้กู้แล้ว ผู้ให้กู้จะแจ้งให้ผู้กู้ทราบผ่านทางระบบอิเล็กทรอนิกส์ ทางไปรษณีย์อิเล็กทรอนิกส์ (E-mail) และ/หรือผ่านทางเอกสารในรูปแบบกระดาษตามที่ผู้ให้กู้เห็นสมควร</p>
    //     <h3>${space}2.2	เงื่อนไขบังคับก่อนสำหรับการเบิกใช้สินเชื่อ</h3>
    //     <p>${space}${space}ผู้กู้รับทราบและตกลงว่าผู้ให้กู้จะให้ผู้กู้เบิกใช้สินเชื่อได้ก็ต่อเมื่อผู้ให้กู้ได้รับเอกสารและหลักฐานต่างๆ ทั้งหมดดังต่อไปนี้จากผู้กู้ ในรูปแบบและเนื้อหาที่ผู้ให้กู้เห็นสมควรแล้ว และผ่านระบบอิเล็กทรอนิกส์ของผู้ให้กู้ หรือช่องทางอื่นใดที่ผู้ให้กู้กำหนด</p>
    //     <p>${space}${space}(ก)	เอกสารและหลักฐานในการยืนยันตัวตนของผู้กู้ และคู่สมรส (ถ้ามี) (รับรองสำเนาถูกต้องโดยเจ้าของเอกสาร)</p>
    //     <p>${space}${space}(ข)	ความยินยอมจากคู่สมรสของผู้กู้ในการเข้าทำและกู้ยืมเงินตามสัญญานี้ (ถ้ามี) </p>
    //     <p>${space}${space}(ค)	สำเนาบัญชีรับเงินกู้ (รับรองสำเนาถูกต้องโดยผู้กู้ และระบุข้อความที่แสดงว่าเป็นบัญชีรับเงินกู้สำหรับการรับเงินกู้ที่เบิกใช้ภายใต้วงเงินสินเชื่อของสัญญานี้)</p>
    //     <p>${space}${space}(ง)	เอกสารอื่นใดที่เป็นเงื่อนไขการเบิกใช้สินเชื่อตามที่ผู้ให้กู้อาจกำหนด (ถ้ามี)</p>
    //     <h3>${space}2.3 เงื่อนไขบังคับก่อนเพิ่มเติมสำหรับการเบิกใช้สินเชื่อ (กรณีมีการค้ำประกันการชำระหนี้ของผู้กู้)</h3>
    //     <p>${space}${space}ภายใต้บังคับของเงื่อนไขอื่นๆ ในสัญญานี้ ผู้ให้กู้จะให้ผู้กู้เบิกใช้สินเชื่อได้ก็ต่อเมื่อภายในวันที่ผู้ให้กู้ออกหนังสือยืนยันตามข้อ 1 ข้างต้น ผู้กู้ต้องส่งมอบสัญญาค้ำประกันสินเชื่อ (ที่ลงนามครบถ้วนแล้ว) และ เอกสารประกอบการทำสัญญาตามที่ระบุในสัญญาค้ำประกันสินเชื่อ ในรูปแบบและเนื้อหาที่ผู้ให้กู้เห็นสมควร (กรณีมีการค้ำประกันการชำระหนี้ของผู้กู้) ให้กับผู้ให้กู้ผ่านระบบอิเล็กทรอนิกส์ของผู้ให้กู้ หรือช่องทางอื่นใดที่ผู้ให้กู้กำหนด</p>
    //     <h3>${space}2.4	หลักฐานแห่งหนี้</h3>
    //     <p>${space}${space}บรรดาบันทึกเอกสารหรือเอกสารใดๆ ที่ผู้ให้กู้ได้จัดทำขึ้นเพื่อการเบิกใช้สินเชื่อ การหักชำระค่าใช้จ่ายที่เกี่ยวข้อง และการโอนเงินกู้ให้แก่ผู้กู้ตามสัญญานี้ ให้ถือว่าเป็นหลักฐานแห่งหนี้ตามสัญญานี้โดยถูกต้อง และให้ถือว่าเอกสารบันทึกหลักฐานดังกล่าว รวมทั้งข้อกำหนด และรายละเอียดเงื่อนไขต่างๆ ที่เกี่ยวข้องกับการดังกล่าวที่มีอยู่แล้ว และที่จะมีขึ้นต่อไปในภายหน้า เป็นส่วนหนึ่งแห่งสัญญานี้ด้วย</p>
    //     <h3>ข้อ 3. 	ดอกเบี้ยและอัตราดอกเบี้ย:     </h3>
    //     <h3>${space}3.1  ดอกเบี้ย</h3>
    //     <p>${space}(ก)	ผู้กู้ตกลงเสียดอกเบี้ยในหนี้เงินต้นค้างชำระในแต่ละงวดให้แก่ผู้ให้กู้ในอัตรา 33 % ต่อปี ทั้งนี้ ผู้ให้กู้อาจเปลี่ยนแปลงอัตราดอกเบี้ยดังกล่าวได้ตามที่ผู้ให้กู้จะประกาศกำหนดเป็นครั้งคราวและแจ้งให้ผู้กู้ทราบ และในการคำนวณดอกเบี้ยตามอัตราดังกล่าวจะเป็นไปตามวิธีการคิดดอกเบี้ยที่กฎหมายกำหนดหรืออนุญาตให้คิดได้และไม่เกินอัตราสูงสุดตามกฎหมายที่อนุญาตให้ผู้ให้กู้เรียกได้ และให้มีการคำนวณเป็นรายวัน โดยกำหนดให้หนึ่งปีเท่ากับ 365 วันตามปฏิทิน</p>
    //     <p>${space}(ข)	ในกรณีที่ผู้กู้ผิดนัด ไม่ปฏิบัติตามข้อกำหนดหรือเงื่อนไข และ/หรือไม่ชำระหนี้ใด ๆ ตามสัญญานี้หรือเอกสารสินเชื่ออื่นใด ผู้กู้ตกลงและยินยอมว่าผู้ให้กู้อาจเรียกดอกเบี้ยในระหว่างเวลาผิดนัดชำระหนี้ ค่าบริการต่าง ๆ เบี้ยปรับ และ/หรือค่าปรับในการชำระหนี้ล่าช้ากว่ากำหนด และ/หรือค่าธรรมเนียมใด ๆ ในอัตรารวมไม่เกินกว่าอัตราสูงสุดผิดเงื่อนไข โดยคิดจากต้นเงินที่ค้างชำระของงวดที่ผิดนัด นับจากวันที่ผู้กู้ผิดนัดชำระหนี้ดังกล่าว จนถึงวันที่ผู้กู้ชำระหนี้ที่ผิดนัดดังกล่าวครบถ้วน </p>
    //     <p>${space}${space}ทั้งนี้ <span STYLE="font-weight:bold">“อัตราสูงสุดผิดเงื่อนไข”</span> หมายความถึง อัตราดอกเบี้ยสูงสุดกรณีผิดนัดชำระหนี้ รวมถึง อัตราค่าบริการต่าง ๆ เบี้ยปรับ ค่าปรับในการชำระหนี้ล่าช้ากว่ากำหนด และค่าธรรมเนียมใด ๆ ที่ผู้ให้กู้ประกาศเรียกเก็บจากผู้กู้ที่เป็นลูกค้าสินเชื่อของผู้ให้กู้ ซึ่งอยู่ในกลุ่มและประเภทสินเชื่อเดียวกับผู้กู้ ปัจจุบันเท่ากับอัตรา 33% ต่อปี ซึ่งอัตราดอกเบี้ยดังกล่าวอาจเปลี่ยนแปลงได้ตามที่ผู้ให้กู้จะประกาศกำหนดเป็นครั้งคราวและแจ้งให้ผู้กู้ทราบ แต่ต้องไม่เกินกว่าอัตราดอกเบี้ยผิดนัดสูงสุดที่กฎหมายอนุญาตให้ผู้ให้กู้เรียกได้ และให้มีการคำนวณเป็นรายวัน โดยกำหนดให้หนึ่งปีเท่ากับ 365 วันตามปฏิทิน</p>
    //     <p>${space}รายละเอียดและอัตราเรียกเก็บดอกเบี้ย เบี้ยปรับ ค่าปรับ ค่าบริการ ค่าธรรมเนียม และค่าใช้จ่ายใด ๆ ปรากฏตาม<span STYLE="font-weight:bold"> เอกสารแนบ ก.</span></p>
    //     <p>${space}3.2 	ในกรณีที่ผู้ให้กู้จะเปลี่ยนแปลงอัตราดอกเบี้ยใดตามสัญญานี้ ผู้ให้กู้จะแจ้งให้ผู้กู้ทราบล่วงหน้าเป็นลายลักษณ์อักษร (ซึ่งจะต้องมีขนาดของตัวอักษรไม่เล็กกว่าสองมิลลิเมตร) โดย (1) หากเป็นกรณีทั่วไป จะแจ้งให้ผู้กู้ทราบล่วงหน้าเป็นระยะเวลาไม่น้อยกว่า 30 วัน และ (2) หากเป็นกรณีเร่งด่วน ผู้ให้กู้อาจจะแจ้งการเปลี่ยนแปลงทางจดหมาย (ซึ่งรวมถึงแต่ไม่จำกัดเพียง จดหมายที่ส่งให้ทางไปรษณีย์ ทางไปรษณีย์อิเล็กทรอนิกส์ (E-mail) และ/หรือช่องทางอื่นใด) หรือประกาศทางหนังสือพิมพ์รายวันภาษาไทยที่แพร่หลายในประเทศล่วงหน้าเป็นระยะเวลาไม่น้อยกว่า 7 วัน และกรณีที่แจ้งโดยประกาศทางหนังสือพิมพ์ ผู้ให้กู้จะแจ้งการเปลี่ยนแปลงดังกล่าวเป็นลายลักษณ์อักษรไปยังผู้กู้ในภายหลังอีกครั้ง และให้ถือว่าอัตราดอกเบี้ยที่มีการเปลี่ยนแปลงนั้นมีผลใช้บังคับตั้งแต่วันถัดจากวันที่ครบกำหนดระยะเวลาดังกล่าวข้างต้นเป็นต้นไป </p>
    //     <h3>ข้อ 4. 	การจ่ายชำระคืนหนี้เงินกู้ :</h3>
    //     <p>${space}4.1	ผู้กู้ตกลงจะชำระคืนเงินกู้ที่ค้างชำระ เป็นรายเดือน เป็นจำนวนตามที่ระบุไว้ในหนังสือยืนยัน หรือเอกสารอันใดตามที่ผู้ให้กู้เห็นสมควร และชำระทุกวันที่ ${bankDate.getDate()} ของเดือน ทั้งนี้ ผู้กู้ตกลงและรับทราบว่าวันถึงกำหนดชำระงวดแรก อาจมีระยะเวลามากกว่าหรือน้อยกว่า 30 วัน นับจากวันที่ผู้ให้กู้ได้ส่งมอบเงินกู้ให้แก่ผู้กู้     <br>    <br>
    //     โดยวันชำระคืนเงินกู้งวดสุดท้ายคือ ${getFullDate(endDate)}</p>
    //     <p>${space}4.2	ผู้กู้ตกลงและรับทราบว่าการคำนวณดอกเบี้ยที่ผู้กู้ต้องผ่อนชำระให้แก่ผู้ให้กู้นั้นจะคำนวณโดยวิธีการคำนวณแบบลดต้นลดดอกเช่นเดียวกับธรรมเนียมปฏิบัติโดยทั่วไปของสถาบันการเงิน</p>
    //     <p>${space}4.3	ผู้กู้ตกลงนำเงินมาชำระหนี้ตามสัญญานี้ให้แก่ผู้ให้กู้ตามเงื่อนไขและรายละเอียดที่กำหนดไว้ในหนังสือยืนยัน โดยจะต้องชำระตามจำนวน กำหนดเวลาและวิธีการที่ระบุในใบแจ้งยอดรายการ (ตามแบบที่ผู้ให้กู้กำหนด) ที่ผู้ให้กู้ได้จัดส่งให้แก่ผู้กู้ในแต่ละเดือนทางช่องทางและรูปแบบของข้อมูลอิเล็กทรอนิกส์หรือรูปแบบอื่นใด ตามที่ผู้กู้กำหนด (ซึ่งต่อไปนี้จะเรียกว่า <span STYLE="font-weight:bold">“ใบแจ้งยอดรายการ”</span>)</p>
    //     <p>${space}4.4	ในกรณีที่ผู้กู้ขอชำระหนี้คืนก่อนกำหนด ผู้กู้จะต้องชำระดอกเบี้ยทั้งหมดที่ผู้กู้ค้างชำระอยู่กับผู้ให้กู้ ณ วันที่ผู้กู้ชำระคืนก่อนกำหนด ตลอดจนชำระค่าใช้จ่าย และเงินใด ๆ ที่ผู้กู้ค้างชำระอยู่กับผู้ให้กู้ (ถ้ามี) นอกจากนี้ในกรณีที่เป็นการชำระหนี้คืนก่อนกำหนดบางส่วน ผู้กู้ตกลงยินยอมให้ผู้ให้กู้นำเงินที่ชำระนั้นไปหักชำระหนี้สินเชื่อที่ผู้กู้ต้องชำระในงวดถัดไปก่อน</p>
    //     <h3>ข้อ 5. 	ค่าธรรมเนียม ค่าปรับ ค่าใช้จ่ายต่าง ๆ หรือค่าใช้จ่ายใดตามสัญญานี้ : </h3>
    //     <p>${space}5.1	ผู้กู้ตกลงชำระค่าอากรแสตมป์ ค่าธรรมเนียม ค่าปรับ ค่าบริการ ค่าใช้จ่ายที่เกิดขึ้นเนื่องจากการปฏิบัติตามสัญญานี้และเอกสารสินเชื่ออื่น ๆ  หรือเกี่ยวเนื่องกับการทำสัญญานี้และเอกสารสินเชื่ออื่น ๆ รวมทั้งค่าใช้จ่าย และค่าเสียหายที่เกิดขึ้นเนื่องจากการทวงถาม ดำเนินคดี ค่าทนายความ ค่าฤชาธรรมเนียมในการดำเนินคดี ตลอดจนการบังคับคดี และการบังคับชำระหนี้ รายละเอียดและอัตราเรียกเก็บปรากฏตาม <u STYLE="font-weight:bold">เอกสารแนบ ก.</u> (ซึ่งต่อไปนี้จะเรียกว่า <span STYLE="font-weight:bold">“ค่าใช้จ่ายที่เกี่ยวข้อง”</span>) โดยผู้กู้ยินยอมให้ผู้ให้กู้หักเงินจากสินเชื่อเพื่อนำไปชำระให้แก่ผู้ที่เกี่ยวข้องได้ทันที ทั้งนี้ ตามวิธีปฏิบัติและภายในกำหนดเวลาที่ผู้ให้กู้กำหนด และให้ถือว่าการดำเนินการดังกล่าวเป็นการที่ผู้กู้ได้เบิกและรับสินเชื่อตามจำนวนเงินที่ถูกหักดังกล่าวถูกต้องแล้วด้วย นอกจากนี้ ผู้กู้ยินยอมให้ผู้ให้กู้มีสิทธิทดรองจ่ายเงินดังกล่าวแทนผู้กู้ไปก่อนได้ ในกรณีที่ผู้ให้กู้ได้ทดรองจ่ายเงินแทนผู้กู้ไปก่อน ผู้ให้กู้จะแจ้งให้ผู้กู้ทราบในใบแจ้งยอดรายการ และผู้กู้ตกลงชดใช้เงินตามจำนวนที่ผู้ให้กู้ได้จ่ายไปก่อนนั้นคืนให้แก่ผู้ให้กู้จนครบถ้วนภายในระยะเวลาที่กำหนดไว้ในใบแจ้งยอดรายการ</p>
    //     <p>${space}5.2	ในกรณีที่ผู้ให้กู้ตกลงเปลี่ยนแปลงอัตราค่าธรรมเนียมที่ใช้อยู่ขณะนี้ให้เพิ่มสูงขึ้น ผู้ให้กู้จะแจ้งให้ผู้กู้ทราบล่วงหน้าอย่างน้อย 30 วัน นอกจากนี้ ผู้ให้กู้ขอสงวนสิทธิ์ในการคืนค่าธรรมเนียมที่ผู้กู้ชำระให้แก่ผู้ให้กู้แล้ว
    //     ทั้งนี้ ในกรณีที่มีการเรียกเก็บค่าธรรมเนียมการชำระเงินดังกล่าว ผู้กู้มีหน้าที่ต้องชำระค่าธรรมเนียมดังกล่าวทั้งหลายตามอัตราและวิธีการที่ผู้ให้กู้กำหนด</p>
    //     <h3>ข้อ 6. 	คำรับรองและคำยืนยัน :    </h3>
    //     <p>${space}ตลอดระยะเวลาที่สัญญานี้มีผลใช้บังคับ ผู้กู้ขอให้คำรับรองและคำยืนยันตามที่ระบุไว้แก่ผู้ให้กู้ดังต่อไปนี้</p>
    //     <p>${space}6.1	ผู้กู้เป็นบุคคลธรรมดา มีความสามารถในการเข้าทำสัญญานี้ มิได้เป็นคนวิกลจริต เสมือนไร้ความสามารถ หรือไร้ความสามารถ มิได้เป็นผู้มีหนี้สินล้นพ้นตัว มิได้ถูกศาลสั่งพิทักษ์ทรัพย์หรือถูกเจ้าพนักงานยึดหรืออายัดทรัพย์ หรือมิได้เป็นบุคคลล้มละลาย โดยในวันที่ของสัญญานี้ ผู้กู้มีสถานภาพทางการสมรส ดังนี้</p>
    //     <p>${space}${space}${
    //   data?.marritalStatus == "โสด" ? "[x]" : "[ ]"
    // }&nbsp โสด</p>
    //     <p>${space}${space}${
    //   data?.marritalStatus == "สมรส" ? "[x]" : "[ ]"
    // }&nbsp สมรสกับ ${
    //   data?.marritalStatus == "โสด"
    //     ? "_________"
    //     : `${data?.articlePartner} ${data?.namePartner} ${data?.lastnamePartner}`
    // } และได้รับความยินยอมจากคู่สมรสของผู้กู้ในการเข้าทำและกู้ยืมเงินตามสัญญานี้ พร้อมทั้งได้ส่งมอบความยินยอมดังกล่าวจากคู่สมรสของผู้กู้ให้แก่ผู้ให้กู้แล้ว</p>
    //     <p>${space}6.2	การเข้าทำสัญญา การปฏิบัติตามสัญญา การจัดทำเอกสาร และการดำเนินการอื่นใดตามที่ระบุไว้ในสัญญานี้ เป็นสิ่งที่อยู่ในอำนาจที่ผู้กู้สามารถกระทำได้ และไม่เป็นการขัดต่อกฎหมายหรือข้อจำกัดตามสัญญาหรือข้อผูกพันใด ๆ ที่มีผลผูกพันต่อผู้กู้และผู้กู้ได้ดำเนินการตามที่จำเป็นเพื่ออนุมัติการเข้าทำ ปฏิบัติ และส่งมอบสัญญานี้แล้ว</p>
    //     <p>${space}6.3	ผู้กู้ได้รับอนุญาตและคำยินยอม สิทธิประโยชน์ใดๆ หรือเอกสารอื่นใดจากส่วนราชการ หน่วยงาน และ/หรือบุคคลอื่น ๆ ที่เกี่ยวข้องที่จำเป็นสำหรับการดำเนินการของผู้กู้และเกี่ยวกับการเข้าทำและการปฏิบัติตามสัญญานี้</p>
    //     <p>${space}6.4	เมื่อผู้กู้ได้มีการยืนยันตอบรับข้อตกลงตามสัญญานี้ผ่านระบบอิเล็กทรอนิกส์ของผู้ให้กู้แล้ว สัญญานี้เป็นสัญญาที่ชอบด้วยกฎหมาย เป็นข้อผูกพันตามกฎหมายที่สมบูรณ์และมีผลผูกพันผู้กู้ และสามารถที่จะใช้บังคับกับผู้กู้ได้ตามข้อกำหนดที่ได้ระบุไว้ในสัญญานี้</p>
    //     <p>${space}6.5	การปฏิบัติตามข้อผูกพันใด ๆ ตามสัญญานี้ไม่และจะไม่    </p>
    //     <p>${space}${space}(ก)	เป็นการฝ่าฝืน หรือขัดต่อข้อกำหนด เงื่อนไข คำรับรอง เอกสาร ตราสาร สัญญาข้อตกลง กฎหมาย หรือ ระเบียบข้อบังคับใดที่ผูกพันผู้กู้</p>
    //     <p>${space}${space}(ข)	เป็นการฝ่าฝืนข้อจำกัดใด ๆ ในเรื่องอำนาจการกู้ยืม หรือการก่อหนี้ หรือในเรื่องอำนาจอื่นใดของผู้กู้</p>
    //     <p>${space}6.6	นับจนถึงวันทำสัญญานี้ ไม่มีกระบวนการฟ้องร้อง ดำเนินคดี กระบวนการทางกฎหมายใด ๆ หรือกระบวนการทางอนุญาโตตุลาการ หรือการพิจารณาของหน่วยงานปกครอง ซึ่ง (ก) มีผล หรืออาจมีผลกระทบต่อความสามารถในการชำระหนี้ของผู้กู้ภายใต้สัญญานี้ และ/หรือ (ข) มีมูลคดีในการฟ้องร้องหรือดำเนินคดีดังกล่าวซึ่งค้างพิจารณาอยู่ในศาล หรือหน่วยงานใด ๆ ต่อผู้กู้ และตราบเท่าที่ผู้กู้ทราบไม่มีผู้แสดงท่าทีว่าจะฟ้องร้องผู้กู้ หรือจะบังคับเอากับทรัพย์สิน หรือสิทธิใด ๆ ของผู้กู้ซึ่งจะมีผลกระทบเชิงลบต่อผู้กู้ หรือความสามารถทางการเงินของผู้กู้ในการปฏิบัติตามสัญญานี้ หรือเอกสารอื่นใดที่เกี่ยวข้อง</p>
    //     <p>${space}6.7	ผู้กู้มิได้ทำผิดหรือฝ่าฝืน หรือละเลยกฎหมาย หรือระเบียบข้อบังคับ คำสั่ง ข้อตกลง คำรับรอง ตราสาร สิทธิพิเศษ ใบอนุญาต หนังสืออนุญาต คำอนุญาต ข้อผูกพันหรือหน้าที่ใด ๆ ที่มีผลผูกพันผู้กู้หรือทรัพย์สินหรือรายรับใด ๆ ของผู้กู้โดยที่ผลของการผิด การฝ่าฝืน หรือการละเลยดังกล่าวอาจจะมีผลกระทบอย่างร้ายแรงต่อผู้กู้ ทรัพย์สิน หนี้ หรือสถานะ (ทางการเงิน หรืออื่น ๆ) ของผู้กู้ หรือต่อความสามารถของผู้กู้ในเรื่องการปฏิบัติตามข้อผูกพันของผู้กู้ที่มีอยู่ตามสัญญานี้หรือเอกสารสินเชื่ออื่นใดที่เกี่ยวข้อง และไม่มีเหตุผิดนัดใด ๆ ได้เกิดขึ้น และยังคงดำรงอยู่ที่เกี่ยวข้องกับสัญญานี้หรือเอกสารอื่นใด</p>
    //     <p>${space}6.8	ข้อมูลเกี่ยวกับผู้กู้และข้อมูลใด ๆ ที่ผู้กู้ได้ให้ไว้กับผู้ให้กู้เป็นข้อมูลที่เป็นความจริงถูกต้องและไม่ทำให้ผู้ให้กู้เข้าใจผิดในสาระสำคัญ </p>
    //     <p>${space}6.9	บรรดาข้อมูล เอกสาร หนังสือ และ/หรือหลักฐานอื่นใดที่เกี่ยวข้องที่ผู้กู้ส่งให้แก่ผู้ให้กู้ไม่ว่าผ่านทางช่องทางใด เป็นเอกสารของผู้กู้เองหรือเป็นเอกสารที่ผู้กู้ได้รับมาจากเจ้าของเอกสารและได้รับอนุญาตจากเจ้าของเอกสารให้นำส่งให้ผู้ให้กู้ได้ </p>
    //     <p>${space}6.10	สิทธิของผู้ให้กู้ที่มีต่อผู้กู้และทรัพย์สินของผู้กู้จะมีสิทธิเทียบเท่ากับเจ้าหนี้ที่ไม่มีประกันอื่นๆ ของผู้กู้เป็นอย่างน้อย ยกเว้นบุคคลที่มีบุริมสิทธิตามกฎหมาย</p>
    //     <h3>ข้อ 7. 	กรณีผิดนัด:</h3>
    //     <p>${space}ผู้กู้ตกลงว่า เมื่อเกิดกรณีใดกรณีหนึ่งดังจะกล่าวต่อไปนี้ ให้ถือว่าผู้กู้เป็นผู้ผิดนัด ผิดสัญญา หรือผิดเงื่อนไขตามสัญญานี้ :</p>
    //     <p>${space}7.1	เมื่อลูกหนี้รายใด ๆ ไม่ชำระหนี้สินเชื่อ ดอกเบี้ย ค่าธรรมเนียม ค่าใช้จ่ายที่เกี่ยวข้อง หรือเงินที่ลูกหนี้รายดังกล่าวมีหน้าที่ต้องชำระหนี้ตามเอกสารสินเชื่อ ตามจำนวน และ/หรือ ตามกำหนดเวลาที่ระบุไว้ในใบแจ้งยอดรายการ และ/หรือ เอกสารสินเชื่อ</p>
    //     <p>${space}7.2	เมื่อลูกหนี้รายใด ๆ ไม่ปฏิบัติ หรือปฏิบัติผิดเงื่อนไขที่ระบุไว้ในเอกสารสินเชื่อหรือเอกสารอื่นตามเอกสารสินเชื่อหรือเกี่ยวเนื่องกับเอกสารสินเชื่อ</p>
    //     <p>${space}7.3	เมื่อปรากฎว่า เอกสารหรือหลักฐานที่ลูกหนี้รายใด ๆ มอบให้แก่ผู้ให้กู้ มีข้อความเท็จ หรือเป็นเอกสารปลอม หรือไม่มีผลบังคับทางกฎหมาย ไม่ว่าทั้งหมดหรือแต่เพียงบางส่วน</p>
    //     <p>${space}7.4	เมื่อหนี้สินอื่นของลูกหนี้รายใด ๆ นอกเหนือจากที่ระบุไว้ในเอกสารสินเชื่อ ไม่มีการชำระเมื่อถึงกำหนด หรือเป็นอันต้องชำระก่อนถึงกำหนด หรือเจ้าหนี้ของลูกหนี้รายใด ๆ มีสิทธิเรียกให้ลูกหนี้รายดังกล่าวชำระหนี้ก่อนกำหนดตามเหตุอันสมควร</p>
    //     <p>${space}7.5	เมื่อลูกหนี้รายใด ๆ ถูกฟ้องร้องดำเนินคดี หรือเมื่อเกิดเหตุการณ์อื่นใดที่ผู้ให้กู้เห็นว่า การให้สินเชื่อแก่ผู้กู้อาจทำให้ผู้ให้กู้เสียหาย หรือลูกหนี้รายใด ๆ ไม่สามารถหรือน่าจะไม่สามารถชำระหนี้ให้ผู้ให้กู้ได้ครบถ้วน</p>
    //     <p>${space}7.6	เมื่อลูกหนี้รายใด ๆ ตกเป็นผู้มีหนี้สินล้นพ้นตัว หรือถูกศาลสั่งพิทักษ์ทรัพย์ หรือถูกเจ้าพนักงานยึดหรืออายัดทรัพย์ หรือกระทำการใดอันอาจเป็นเหตุให้ถูกฟ้องล้มละลาย หรือถูกร้องขอให้ล้มละลาย หรือกระทำการประนอมหนี้ หรือถึงแก่ความตาย หรือตกเป็นผู้ไร้ความสามารถ หรือผู้เสมือนไร้ความสามารถ หรือเป็นผู้สาบสูญ หรือไปเสียจากถิ่นที่อยู่หาตัวไม่พบ</p>
    //     <h3>ข้อ 8. 	ผลของการผิดนัด :</h3>
    //     <p>${space}ผู้กู้ตกลงว่าในกรณีที่ผู้กู้ตกเป็นผู้ผิดนัด ผิดสัญญา หรือผิดเงื่อนไขดังที่กล่าวมาในข้อ 7 ข้างต้น และผู้ให้กู้ได้แจ้งเป็นลายลักษณ์อักษรไปยังผู้กู้เพื่อแก้ไขการผิดนัด ผิดสัญญาหรือผิดเงื่อนไขดังกล่าวแล้ว แต่ผู้กู้ไม่ดำเนินการหรือไม่สามารถดำเนินการแก้ไขให้แล้วเสร็จภายในระยะเวลาอันสมควรที่ผู้ให้กู้กำหนดไว้ ให้ผู้ให้กู้มีสิทธิดำเนินการดังต่อไปนี้ </p>
    //     <p>${space}(ก)	ระงับการใช้วงเงินสินเชื่อทั้งหมดหรือบางส่วนไว้ชั่วคราวจนกว่าจะมีการแก้ไขกรณีผิดสัญญาหรือผิดเงื่อนไขดังกล่าว จนเป็นที่พอใจแก่ผู้ให้กู้ และ/หรือ</p>
    //     <p>${space}(ข)	ยกเลิกวงเงินสินเชื่อที่เหลืออยู่ทั้งหมดหรือบางส่วน ซึ่งความผูกพันของผู้ให้กู้ในการให้วงเงินสินเชื่อดังกล่าวจะถูกยกเลิกโดยพลัน และ/หรือ</p>
    //     <p>${space}(ค)	ให้ถือว่าเป็นการผิดนัดในจำนวนหนี้ทั้งหมด โดยให้บรรดาหนี้สินตามสัญญานี้และเอกสารสินเชื่ออื่น ๆ เป็นอันถึงกำหนดชำระ และผู้กู้ตกลงชำระหนี้สินค้างชำระทั้งหมดตามสัญญานี้และเอกสารสินเชื่ออื่น ๆ ให้แก่ผู้ให้กู้ทันที รวมทั้งยินยอมชำระดอกเบี้ยผิดนัดในต้นเงินที่ค้างชำระทั้งหมดในอัตราสูงสุด จนกว่าจะชำระหนี้ทั้งหมดให้เสร็จสิ้น ตลอดจนยินยอมเสียค่าธรรมเนียม และ/หรือ ค่าบริการ และ/หรือ เงินอื่นใดที่ผู้กู้จะต้องชำระให้แก่ผู้ให้กู้ตามข้อกำหนดและเงื่อนไขของสัญญานี้ (ถ้ามีและเท่าที่กฎหมายอนุญาตให้ผู้ให้กู้เรียกได้) ให้ครบถ้วนด้วย และ/หรือ</p>
    //     <p>${space}(ง)	ใช้สิทธิในการบังคับตามเอกสารสินเชื่อต่าง ๆ ไม่ว่าส่วนใดส่วนหนึ่งหรือทั้งหมดได้ </p>
    //     <h3>ข้อ 9. 	การติดต่อทวงถาม :</h3>
    //     <p>${space}ผู้กู้ตกลงเลือกรูปแบบการรับข้อมูลหรือเอกสารใด ๆ ตามสัญญานี้จากผู้ให้กู้ในรูปแบบ</p>
    //     <p>${space}${
    //   String(data?.letter) === "1" ? "[x]" : "[ ]"
    // }${spaceOne}รูปแบบข้อมูลอิเล็กทรอนิกส์</p>
    //     <p>${space}${
    //   String(data?.letter) === "2" ? "[x]" : "[ ]"
    // }${spaceOne}รูปแบบกระดาษ</p>
    //     <p>${space}${space}(หมายเหตุ: หากผู้กู้เลือกรูปแบบการรับข้อมูลหรือเอกสารใด ๆ ตามสัญญานี้ในรูปแบบกระดาษ จะไม่เป็นการตัดสิทธิผู้ให้กู้ในการดำเนินการส่งข้อมูลหรือเอกสารใด ๆ ตามสัญญานี้เพิ่มเติมในรูปแบบข้อมูลอิเล็กทรอนิกส์ด้วย)</p>
    //     <p>${space}คำบอกกล่าว คำทวงถาม หรือการสื่อสารอื่นๆ แต่ละครั้งที่จะต้องส่งให้ หรือทำขึ้นตามสัญญานี้ (ซึ่งรวมถึงแต่ไม่จำกัดเพียง ใบแจ้งหนี้หรือใบแจ้งยอดรายการ เป็นต้น) ให้ส่งให้ หรือทำขึ้นผ่านทางระบบอิเล็กทรอนิกส์ของผู้ให้กู้ และ/หรือทางไปรษณีย์อิเล็กทรอนิกส์ (E-mail) (ยกเว้นที่กำหนดไว้เป็นอย่างอื่นในสัญญานี้ และเท่าที่กฎหมายอนุญาตให้ทำได้) และผู้กู้ตกลงให้ผู้ให้กู้สามารถจัดทำ จัดเก็บ และจัดส่งข้อมูลรวมทั้งเอกสารที่ผู้ให้กู้ต้องเปิดเผยหรือแจ้งต่อผู้กู้ตามสัญญานี้และเอกสารสินเชื่ออื่น ๆ ในรูปแบบข้อมูลอิเล็กทรอนิกส์ (ยกเว้นที่กำหนดไว้เป็นอย่างอื่นในสัญญานี้หรือกฎหมายกำหนดไว้เป็นอย่างอื่น)</p>
    //     <p>${space}ถ้าการติดต่อทวงถามหรือบอกกล่าวซึ่งตามกฎหมายหรือตามสัญญานี้ได้กำหนดหรือให้ต้องแจ้งหรือบอกกล่าวเป็นลายลักษณ์อักษร หากผู้ให้กู้ได้ส่งโดยทางไปรษณีย์ลงทะเบียนตอบรับไปยังที่อยู่ที่ระบุไว้ในรายการขอสินเชื่อทางระบบอิเล็กทรอนิกส์ หรือที่ระบุไว้ในเอกสารสินเชื่อใด ๆ หรือส่งไปยังที่อยู่ที่ผู้กู้ได้แจ้งการย้ายหรือการเปลี่ยนแปลงเป็นลายลักษณ์อักษรครั้งหลังสุดต่อผู้ให้กู้ ให้ถือว่าได้ส่งให้แก่ผู้กู้แล้วโดยชอบ</p>

    //     <h3>ข้อ 10.  การโอนสิทธิ และ/หรือ หน้าที่ตามสัญญานี้ : </h3>
    //     <p>${space}ผู้กู้ตกลงยินยอมให้ผู้ให้กู้ โอนสิทธิ หน้าที่ และ/หรือผลประโยชน์ตามสัญญานี้ไม่ว่าทั้งหมดหรือแต่บางส่วนให้แก่บุคคลผู้หนึ่งผู้ใดได้ โดยผู้ให้กู้จะบอกกล่าวแจ้งการโอนเป็นลายลักษณ์อักษรให้ผู้กู้ทราบล่วงหน้าเป็นระยะเวลาไม่น้อยกว่าหนึ่งรอบงวดบัญชี โดยผู้ให้กู้ไม่จำเป็นต้องได้รับความยินยอมจากผู้กู้อีกแต่อย่างใด </p>

    //     <h3>ข้อ 11.  การเป็นโมฆะ :</h3>
    //     <p>${space}ผู้กู้ตกลง หากข้อกำหนดหรือเงื่อนไขส่วนหนึ่งส่วนใดของสัญญานี้หรือเอกสารสัญญาที่เกี่ยวข้องหรือเกี่ยวเนื่องกับสัญญานี้ใช้บังคับไม่ได้ หรือเป็นโมฆะ หรือไม่สมบูรณ์ หรือไม่ชอบด้วยกฎหมาย ให้มีผลเฉพาะข้อกำหนดหรือเงื่อนไขในส่วนนั้นเท่านั้น โดยข้อกำหนดหรือเงื่อนไขในส่วนอื่นยังคงมีความสมบูรณ์และมีผลใช้บังคับอยู่เช่นเดิมต่อไปและไม่เสื่อมเสียไป เพราะความเป็นโมฆะ ไม่สมบูรณ์ ไม่ชอบด้วยกฎหมาย หรือใช้บังคับมิได้ของข้อความ หรือเอกสารสัญญาที่เกี่ยวข้องฉบับดังกล่าว</p>
    //     <h3>ข้อ 12.  การแก้ไขเงื่อนไขสินเชื่อ :</h3>
    //     <p>${space}ผู้กู้ตกลงยอมรับว่าผู้ให้กู้มีสิทธิทบทวน แก้ไข เปลี่ยนแปลงเพิ่มเติมเงื่อนไขหรือข้อกำหนดใดๆ เกี่ยวกับสินเชื่อ ไม่ว่าตามสัญญานี้ หรือข้อตกลงอื่นใดได้ โดยในการดำเนินการดังกล่าวหากจะมีผลทำให้ผู้กู้เสียประโยชน์อย่างมีนัยสำคัญ ผู้ให้กู้จะแจ้งให้ผู้กู้ทราบล่วงหน้าอย่างน้อย 30 วันก่อนการเปลี่ยนแปลงเพิ่มเติมดังกล่าวจะมีผลบังคับใช้</p>
    //     <h3>ข้อ 13.  การไม่ใช้สิทธิที่มีอยู่ตามสัญญา :</h3>
    //     <p>${space}ในกรณีที่ผู้ให้กู้ละเลยไม่ใช้ หรือล่าช้าต่อการใช้สิทธิทั้งหมดหรือแต่เพียงบางส่วนตามสัญญานี้ไม่ทำให้ผู้ให้กู้เสียสิทธิ และไม่ถือว่าเป็นการสละสิทธิหรือการยินยอมให้ผู้กู้ไม่ปฎิบัติตามสัญญานี้ รวมทั้งไม่ตัดสิทธิผู้ให้กู้ที่จะใช้สิทธิตามสัญญานี้ หรือสิทธิอื่น ๆ รวมถึงสิทธิตามกฎหมาย</p>
    //     <h3>ข้อ 14.  เบ็ดเตล็ด  และ/หรือรายละเอียดเงื่อนไขอื่นใดที่เกี่ยวกับสัญญาสินเชื่อ : </h3>
    //     <p>${space}14.1	ผู้กู้ตกลงยอมรับว่า การกำหนดดอกเบี้ย และ/หรือ การทำข้อตกลงต่างๆ ตามสัญญานี้ เป็นการดำเนินการตามหลักเกณฑ์และข้อกำหนดตามกฎหมาย และของหน่วยงานราชการที่ใช้อยู่ในขณะนี้ ดังนั้น หากในภายหน้ามีการเปลี่ยนแปลงหลักเกณฑ์ และ/หรือ ข้อกำหนดดังกล่าว ผู้กู้ตกลงยินยอมให้ผู้ให้กู้มีสิทธิแก้ไขเปลี่ยนแปลงดอกเบี้ย และ/หรือ ข้อตกลงตามสัญญานี้ได้ใหม่เพื่อให้เป็นไปตามหลักเกณฑ์และเงื่อนไขที่ได้มีการเปลี่ยนแปลงหรือเพิ่มเติมดังกล่าวโดยผู้ให้กู้จะปิดประกาศการกำหนดหรือแจ้งการเปลี่ยนแปลงดอกเบี้ย และ/หรือ ข้อตกลงไว้ ณ สำนักงานใหญ่และสาขา (ถ้ามี) ของผู้ให้กู้ และผ่านทางช่องในระบบอิเล็กทรอนิกส์ของผู้ให้กู้ รวมทั้งจะเผยแพร่ในเว็บไซต์ของผู้ให้กู้ เพื่อให้ผู้กู้ได้ทราบล่วงหน้าไม่น้อยกว่า 30 วัน ก่อนจะมีผลบังคับใช้ ทั้งนี้ เมื่อครบระยะเวลาดังกล่าวแล้ว ผู้กู้ตกลงปฏิบัติตามหลักเกณฑ์ และ/หรือ ข้อกำหนดที่มีการเปลี่ยนแปลงใหม่นั้น</p>
    //     <p>${space}14.2	ผู้กู้ตกลงยอมรับว่า ในกรณีที่ผู้กู้สมัครหรือขอใช้บริการแจ้งเตือน หรือ บริการอื่นใดของผู้ให้กู้ที่เกี่ยวข้องกับสินเชื่อ ไม่ว่าจะได้มีการสมัครหรือขอใช้บริการแจ้งเตือนหรือบริการอื่นใดหรือไม่ โดยผ่านช่องทางการสมัครหรือขอใช้บริการผ่านช่องทางการสมัครใดก็ตาม ทั้งนี้ ไม่ว่าจะเป็นในรูปแบบอิเล็กทรอนิกส์ หรือหลักฐานอื่นใดหรือการลงลายมือชื่อของผู้กู้ หรือรูปแบบอื่นใด ผู้กู้ตกลงยอมรับว่าจะปฏิบัติตามข้อกำหนดและเงื่อนไขการใช้บริการแจ้งเตือนหรือบริการอื่นใดดังกล่าวข้างต้นด้วย อนึ่ง ผู้กู้ได้อ่านทำความเข้าใจและอาจจะสั่งพิมพ์ออก (Print Out) ซึ่งข้อกำหนดและเงื่อนไขดังกล่าวจากเว็บไซต์ของผู้ให้กู้ก็ได้</p>
    //     <p>${space}14.3	รายละเอียดในเรื่องอื่นที่เกี่ยวกับการใช้สินเชื่อ นอกจากที่ได้กำหนดไว้ข้างต้นแล้ว ผู้กู้ตกลงปฏิบัติตามข้อกำหนด และเงื่อนไขที่จะมีการแก้ไขเพิ่มเติมตามที่ผู้ให้กู้จะได้แจ้งให้ทราบภายหน้า และหรือ เอกสารอื่นที่เกี่ยวข้องกับสัญญานี้ รวมทั้งข้อกำหนดและเงื่อนไขอื่นที่ผู้ให้กู้ประกาศกำหนดเป็นการทั่วไป ทั้งนี้ไม่ว่าที่มีอยู่แล้วในขณะนี้ และที่จะมีขึ้นในภายหน้าก็ตาม</p>
    //     <p>${space}14.4	บรรดาหลักฐาน เอกสาร หนังสือ และ/หรือ สัญญาอื่นที่เกี่ยวข้องกับสัญญานี้ และ/หรือ ที่ผู้กู้ทำให้ไว้แก่ผู้ให้กู้เพื่อเป็นการปฏิบัติตามวัตถุประสงค์ และ/หรือ เงื่อนไขของสัญญานี้ ให้ถือเป็นส่วนหนึ่งของสัญญานี้ด้วย</p>
    //     <p>${space}14.5	สัญญานี้ และเอกสาร สิทธิและข้อผูกพันต่างๆ ของคู่สัญญาที่มีอยู่ตามสัญญานี้ ให้บังคับ ตีความ และแปลความหมายตามกฎหมายไทยในทุกๆ ประการ ส่วนการฟ้องร้องบังคับคดีตามสัญญานี้ให้ดำเนินการ ณ ศาลแห่งราชอาณาจักรไทยตามเขตอำนาจศาลที่กำหนดไว้ในกฎหมาย</p>
    //     <p>${space}14.6 บรรดาหนังสือติดต่อทวงถาม หนังสือบอกกล่าวหรือหนังสืออื่นใดที่จะส่งให้แก่ผู้นั้น โดยการส่งทางไปรษณีย์ลงทะเบียนตอบรับ หากได้ส่งไปยังที่อยู่ของผู้กู้ที่ได้ระบุไว้ตามสัญญา หรือที่อยู่ที่ผู้กู้ได้แจ้งเปลี่ยนไว้เป็นหนังสือหลังสุด ให้ถือว่าบริษัทฯ ได้ส่งเอกสารดังกล่าวให้แก่ผู้กู้โดยชอบ ทั้งนี้โดยไม่คำนึงว่าจะมีผู้รับไว้หรือไม่ ให้ถือว่าผู้กู้ได้รับและทราบหนังสือติดต่อทวงถาม บอกกล่าว หรือหนังสืออื่นใดของบริษัท แล้วโดยชอบ</p>
    //     <p>${space}14.7 กรณีผู้กู้ไม่สามารถติดต่อได้ ทางบริษัทจะติดต่อไปยังบุคคลติดต่อฉุกเฉินทั้งสองท่าน และในกรณีไม่สามารถติดต่อผู้กู้และบุคคลติดต่อฉุกเฉินมากกว่า 30 วัน ทางบริษัทจะใช้ข้อมูลสมุดโทรศัพท์ที่ผู้กู้ได้อนุญาตในแอพพลิเคชั่น สำหรับการติดต่อลำดับถัดไป โดยทางบริษัทจะขออนุญาตการสนทนากับปลายสายก่อนทุกครั้ง และจะไม่มีการแจ้งหนี้ใดๆ กับปลายสายดังกล่าว โดยบริษัทมีวัตถุประสงค์เพื่อเป็นการรักษาสิทธิและประโยชน์ของผู้กู้เองเท่านั้น</p>
    //     <p>${space}14.8 กรณีลูกค้าชำระหนี้เกินยอดค่างวดที่ต้องชำระในแต่ละงวดหรือชำระหนี้เกินยอดหนี้ที่ต้องชำระในครั้งใดๆก็ดี หากลูกค้าประสงค์ขอรับเงินซึ่งชำระเกินมาคืน ลูกค้าต้องติดต่อมายังบริษัทตามช่องทางที่บริษัทกำหนดเพื่อขอรับเงินคืน และยินยอมชำระค่าใช้จ่ายแก่บริษัทในการดำเนินการคืนเงินแก่ลูกค้าเป็นเงินจำนวน 20 บาทรวมตลอดถึงค่าธรรมเนียมต่างๆที่เกิดขึ้นแก่บริษัท อันเนื่องมาจากการคืนเงินแก่ลูกค้าด้วย</p>

    //     <h2 class="h2">เอกสารแนบ ก.</h2>
    //     <p style="text-align: center">ชื่อผู้ให้กู้<span STYLE="font-weight:bold"> บริษัท มันนี่ ฮับ เซอร์วิส จำกัด</span></p>
    //     <p style="text-align: center">รายละเอียดเกี่ยวกับอัตราดอกเบี้ย เบี้ยปรับ ค่าปรับ ค่าบริการ ค่าธรรมเนียมใด ๆ </p>
    //     <p style="text-align: center">และค่าใช้จ่ายใด ๆ [ตามที่ได้จ่ายจริงและพอสมควรแก่เหตุเกี่ยวกับสินเชื่อส่วนบุคคลภายใต้การกำกับที่มิใช่สินเชื่อที่มีทะเบียนรถเป็นประกัน]/[ที่ผู้ประกอบธุรกิจอาจเรียกได้ในการประกอบธุรกิจสินเชื่อรายย่อยเพื่อการประกอบอาชีพภายใต้การกำกับ </p>
    //     <p style="text-align: center">เริ่มใช้ตั้งแต่วันที่ ${getFullDate(
    //       completeDate
    //     )} </p>
    //     <h3>(1)อัตราดอกเบี้ยแบบลดต้นลดดอก</h3>
    //     <p>ดอกเบี้ยร้อยละ 33 ต่อปี กรณีสินเชื่อเพื่อการประกอบอาชีพ (Effective rate) <br> ดอกเบี้ยร้อยละ 25 ต่อปี กรณีสินเชื่อเพื่ออุปโภค บริโภค และการท่องเที่ยว (Effective rate) และไม่เกินกว่าอัตราดอกเบี้ยสูงสุดกรณีปกติสำหรับสินเชื่อนี้ รวมทั้ง เมื่อคำนวณดอกเบี้ย เบี้ยปรับ ค่าปรับ ค่าบริการ ค่าธรรมเนียมใดๆ และค่าใช้จ่ายอื่นๆรวมกัน</p>
    //     <h3>(2) การคำนวณดอกเบี้ยและค่าธรรมเนียมการใช้วงเงิน</h3>
    //     <p>${space}${symbol}${spaceOne}การคำนวณดอกเบี้ย : รายวัน </p>
    //     <p>${space}${symbol}${spaceOne}จำนวนวันต่อปีที่ใช้ในการคำนวณดอกเบี้ย : 365 วัน </p>
    //     <p>${space}${symbol}${spaceOne}อัตราค่าธรรมเนียมการใช้วงเงิน : ไม่มีค่าธรรมเนียม </p>
    //     <h3>(3) ค่าธรรมเนียมและค่าบริการ</h3>
    //     <p>${space}${symbol}${spaceOne}ค่าอากรแสตมป์ : ไม่มีเรียกเก็บค่าอากรแสตมป์ </p>
    //     <p>${space}${symbol}${spaceOne}ค่าใช้จ่ายในตรวจสอบข้อมูลเครดิต : ไม่มีเรียกเก็บ </p>
    //     <p>${space}${symbol}${spaceOne}ค่าติดตามทวงถามหนี้ : มีการเรียกเก็บแล้วแต่กรณีไม่เกินที่กฎหมายกำหนด </p>
    //     <p>${space}${symbol}${spaceOne}ค่าธรรมเนียมชำระเงิน ผ่านช่องทางผู้ให้บริการรายอื่น : ขึ้นอยู่กับผู้ให้บริการรายนั้น ๆ </p>
    //     <p>${space}${symbol}${spaceOne}Bill Payment : QR Code พร้อมเพย์ :  ไม่มีค่าธรรมเนียม</p>
    //     <p>(<span STYLE="font-weight:bold">หมายเหตุ :</span> อัตราค่าธรรมเนียมอาจมีการเปลี่ยนแปลงได้ ซึ่งเป็นไปตามประกาศของบริษัทฯ ซึ่งสามารถตรวจสอบได้ผ่านเว็บไซต์ www.moneyhubservice.com)</p>
    //     <br>
    //     <br>
    //     <br>
    //     <br>
    //     <div style="clear:both"><h4 style="text-align: right">ข้าพเจ้า ${
    //       data?.article
    //     } ${data?.name} ${data?.lastname} </h4></div>
    //     <div style="clear:both"><h4 style="text-align: right">(ผู้กู้/ผู้รับผลประโยชน์)</h4></div>
    //     <div style="clear:both"><h4 style="text-align: right">เบอร์โทร ${
    //       data?.phone_number
    //     }</h4></div>
    //     <div style="clear:both"><h4 style="text-align: right">ยืนยันด้วยระบบอิเล็กทรอนิกส์ว่าข้อมูลของข้าพเจ้าถูกต้องและเป็นความจริงทุกประการ</h4></div>
    //     <div style="clear:both"><h4 style="text-align: right">วันที่ ${getFullDate(
    //       today,
    //       { showMonth: true }
    //     )}</h4></div>
    //     <br>
    //     <br>
    //     <br>
    //     <br>
    //     <br>
    //     <br>
    //     <br>
    //     <br>
    //     <br>
    //     <br>
    // </body>
    // </html>
    // `;
    // return htmlContent;
  };

  // return getHtmlFinalPdf(data)

  return (
    // <Document>
    //   <Page>
    //     <Html>{getHtmlFinalPdf(data)}</Html>
    //   </Page>
    // </Document>
    // <PDFViewer width={980} height={1100}>
    <Document>
      <Page size="A4" style={styleFinal.page}>
        <Text style={styleFinal.header}>สัญญาสินเชื่อ&nbsp;&nbsp;</Text>
        <Text style={{ marginTop: "18px", textAlign: "center" }}>
          คำขอรับสินเชื่อและสัญญาสินเชื่อฉบับนี้ (“สัญญานี้”) ทำขึ้นเมื่อวันที่{" "}
          {getFullDate(today, { showMonth: true })}
        </Text>
        <Text style={styleFinal.p}>
          โดย {data?.article} {data?.name} {data?.lastname}
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </Text>
        <Text style={styleFinal.p}>
          ที่อยู่ {data?.addressCode} {data?.addressDesc} {data?.address}
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </Text>
        <Text style={styleFinal.p}>อีเมล {data?.email}</Text>
        <Text style={styleFinal.p}>เบอร์โทรติดต่อ {data?.phone_number}</Text>
        <Text style={styleFinal.p}>
          เลขประจำตัวบัตรประชาชน {data?.citizenid}
        </Text>
        <Text style={styleFinal.p}>
          อายุ {data?.age} ปี สถานภาพ {data?.marritalStatus}{" "}
          {data?.marritalStatus == "สมรส"
            ? "กับ" +
              `${data?.articlePartner} ${data?.namePartner} ${data?.lastnamePartner}`
            : ""}
          &nbsp;&nbsp;
        </Text>
        <Text style={styleFinal.p}>
          ซึ่งเป็นผู้ใช้แอปพลิเคชันของ บริษัท มันนี่ ฮับ เซอร์วิส จำกัด
          และมีชื่อปรากฎอยู่ด้านหน้าของแอปพลิเคชันดังกล่าว และในสัญญานี้
          ในฐานะผู้กู้ (ซึ่งต่อไปในสัญญานี้จะเรียกว่า “ผู้กู้”)&nbsp;
        </Text>
        <Text style={styleFinal.p}>
          ผู้กู้มีความประสงค์ขอสินเชื่อจาก บริษัท มันนี่ ฮับ เซอร์วิส จำกัด
          บริษัทจำกัดจดทะเบียนตามกฎหมายไทย (ทะเบียน&nbsp;&nbsp;
        </Text>
        <Text>
          นิติบุคคลเลขที่{" "}
          <Text style={{ textDecoration: "underline" }}>0105563138266</Text>)
          และ มีสำนักงานจดทะเบียนตั้งอยู่เลขที่{" "}
          <Text style={{ textDecoration: "underline" }}>
            1010 อาคารชินวัตรทาวเวอร์ 3 ชั้นที่ 12 ถนนวิภาวดีรังสิต แขวงจตุจักร
            เขตจตุจักร กรุงเทพมหานคร
          </Text>
          &nbsp;เบอร์โทรติดต่อ 02-821-6710 อีเมล{" "}
          <Text style={{ textDecoration: "underline" }}>support@money</Text>
          &nbsp;&nbsp;
        </Text>
        <Text>
          <Text style={{ textDecoration: "underline" }}>hubservice.com</Text>{" "}
          ในฐานะผู้ให้กู้ (ซึ่งต่อไปนี้จะเรียกว่า “ผู้ให้กู้”)
          โดยการสมัครผ่านระบบอิเล็กทรอนิกส์ของผู้ให้กู้&nbsp;
        </Text>
        <Text>
          ไม่ว่าระบบใด (ไม่ว่าจะเป็นช่องทางแอปพลิเคชันในโทรศัพท์มือถือ
          อินเทอร์เน็ตหรือระบบอิเล็กทรอนิกส์อื่นใดใน
        </Text>
        <Text>
          ทำนองเดียวกัน) (ซึ่งต่อไปนี้จะเรียกว่า “ระบบอิเล็กทรอนิกส์”)
          ที่ผู้ให้กู้ได้กำหนดไว้ให้ใช้ในการขอสินเชื่อตาม&nbsp;&nbsp;
        </Text>
        <Text>สัญญานี้ได้&nbsp;</Text>
        <Text style={styleFinal.p}>
          ผู้กู้ได้อ่านและทำความเข้าใจในข้อกำหนดและเงื่อนไขทั้งปวงของสัญญานี้
          (รวมทั้งรับทราบและตกลงในวงเงินที่ผู้&nbsp;&nbsp;
        </Text>
        <Text>
          ให้กู้จะอนุมัติให้)
          และผู้กู้สัญญาต่อผู้ให้กู้ว่าจะปฏิบัติและยินยอมผูกพันตนตามข้อกำหนดและรายละเอียดเงื่อนไข&nbsp;
        </Text>
        <Text>
          ต่างๆของสัญญานี้ ข้อกำหนดและข้อตกลงเงื่อนไขต่างๆ
          ในการขอใช้บริการสินเชื่อ
          และเอกสารอื่นใดที่เกี่ยวข้องกับ&nbsp;&nbsp;&nbsp;&nbsp;
        </Text>
        <Text>
          สินเชื่อที่ผู้ให้กู้จะกำหนดและให้มีผลใช้บังคับเป็นคราว ๆ ไปทุกประการ
          (ซึ่งต่อไปนี้จะเรียกสัญญานี้และเอกสาร&nbsp;&nbsp;
        </Text>
        <Text>
          ดังกล่าว)
          ตลอดจนสัญญาค้ำประกันที่เป็นประกันการชำระหนี้ของผู้กู้ตามสัญญา
          หนี้ของผู้กู้ตามสัญญานี้และเอกสาร&nbsp;&nbsp;
        </Text>
        <Text>
          สินเชื่ออื่น ๆ (ถ้ามี) (ตามที่อาจมีการแก้ไข เพิ่มเติม
          และ/หรือเปลี่ยนแปลง เป็นครั้งคราว) รวมกันว่า “เอกสาร
          สินเชื่อ”)&nbsp;&nbsp;
        </Text>
        <Text style={styleFinal.p}>
          เพื่อเป็นหลักฐานสำคัญสำหรับการรับสินเชื่อของผู้กู้จากผู้ให้กู้
          ผู้กู้ตกลงต่อผู้ให้กู้ดังมีรายละเอียดต่อไปนี้&nbsp;&nbsp;
        </Text>
        <Text style={{ marginTop: "100px", ...styleFinal.topic }}>
          ข้อ 1. วงเงินสินเชื่อที่ผู้ให้กู้อนุมัติ :
        </Text>
        <Text style={{ marginTop: "20px" }}>
          ผู้กู้ตกลงกู้และขอรับสินเชื่อในรูปแบบของเงินกู้ยืม
          เพื่อวัตถุประสงค์ตามที่ระบุไว้ข้างล่างนี้
        </Text>
        <Text style={{ marginTop: "10px" }}>
          &nbsp;&nbsp;{type == 1 ? "[x]" : "[ ]"}
          &nbsp;&nbsp;เพื่อการอุปโภคบริโภค / เพื่อการท่องเที่ยว
        </Text>
        <Text style={{ marginTop: "10px" }}>
          &nbsp;&nbsp;{type == 3 ? "[x]" : "[ ]"}
          &nbsp;&nbsp;เพื่อการประกอบอาชีพ
        </Text>
        <Text style={{ marginTop: "10px" }}>
          &nbsp;&nbsp;[ ]&nbsp;&nbsp;ไม่ระบุวัตถุประสงค์
        </Text>
        <Text style={{ marginTop: "10px" }}>
          โดยไม่มีทรัพย์หรือทรัพย์สินเป็นหลักประกัน และ
        </Text>
        <Text style={{ marginTop: "10px" }}>
          &nbsp;&nbsp;[x]&nbsp;&nbsp;ไม่มีการค้ำประกันการชำระหนี้ของผู้กู้{" "}
        </Text>
        <Text style={{ marginTop: "10px" }}>
          &nbsp;&nbsp;[ ]&nbsp;&nbsp;มีการค้ำประกันการชำระหนี้ของผู้กู้
          โดย________________
        </Text>
        <Text style={{ marginTop: "10px" }}>
          (ซึ่งต่อไปนี้จะเรียก ผู้กู้ และ/หรือ ผู้ค้ำประกัน (ถ้ามี)
          แยกกันและรวมกันว่า{" "}
          <Text style={{ fontWeight: "bold" }}>“ลูกหนี้”</Text>{" "}
          และเรียกสินเชื่อข้างต้นว่า
        </Text>
        <Text>
          <Text style={{ fontWeight: "bold" }}>“สินเชื่อ”</Text>)
        </Text>
        <Text style={{ marginTop: "20px" }}>
          &nbsp;&nbsp;&nbsp;&nbsp;จากผู้ให้กู้ โดยขอให้วันเบิกใช้สินเชื่อเป็น
          วันที่ {getFullDate(completeDate)} โดยมีวงเงินกู้เป็นจำนวน&nbsp;
          {data?.requestamount} บาท
        </Text>
        <Text>
          ({THBText(data?.requestamount)})
          ผู้กู้ตกลงและรับทราบว่าในกรณีที่ผู้ให้กู้อนุมัติการให้กู้
          ผู้ให้กู้จะมีการแจ้งยืนยันการ&nbsp;&nbsp;
        </Text>
        <Text>
          อนุมัติการให้กู้และจำนวนเงินกู้เป็นหนังสือยืนยันการอนุมัติวงเงินสินเชื่อ
          (ซึ่งต่อไปนี้จะเรียกว่า&nbsp;
          <Text style={{ fontWeight: "bold" }}>“หนังสือยืนยัน”</Text>)&nbsp;
          ให้ผู้กู้ทราบผ่านทางระบบอิเล็กทรอนิกส์ ทางโทรศัพท์
          ทางไปรษณีย์อิเล็กทรอนิกส์ (E-mail) และ/หรือบอกกล่าว
          เป็นลายลักษณ์อักษรในรูปแบบกระดาษตามที่ผู้ให้กู้เห็นสมควรและผู้กู้ตกลงรับทราบว่าผู้ให้กู้อาจเปลี่ยนแปลง
        </Text>
        <Text>
          วงเงินกู้ดังกล่าวโดยแจ้งให้แก่ผู้กู้รับทราบต่อไปได้&nbsp;&nbsp;
        </Text>
        <Text style={{ marginTop: "20px" }}>
          &nbsp;&nbsp;&nbsp;&nbsp;ทั้งนี้
          ผู้ให้กู้มีสิทธิในการพิจารณาอนุมัติหรือไม่อนุมัติการให้กู้ได้ตามดุลยพินิจโดยเด็ดขาดของผู้ให้กู้โดยผู้กู้ได้รับ
        </Text>
        <Text>สัญญานี้ และเอกสารสินเชื่ออื่น ๆ จากผู้ให้กู้เรียบร้อยแล้ว</Text>
        <Text style={{ marginTop: "20px", ...styleFinal.topic }}>
          ข้อ 2. เงื่อนไขการเบิกใช้สินเชื่อ :
        </Text>
        <Text style={{ marginTop: "20px", marginTop: "10px" }}>
          &nbsp;&nbsp;&nbsp;&nbsp;2.1
          ผู้กู้ตกลงขอเบิกและรับเงินสินเชื่อจากผู้ให้กู้{" "}
          <Text style={{ fontWeight: "bold" }}>ครั้งเดียวทั้งจำนวน&nbsp;</Text>
          ในวันที่ระบุไว้ในข้อ 1 ข้างต้นโดยขอให้
          ผู้ให้กู้นำเงินจำนวนดังกล่าวไปเข้าบัญชีเงินฝากของผู้กู้ที่ระบุอยู่ในรายการขอสินเชื่อบนระบบอิเล็กทรอนิกส์&nbsp;&nbsp;
          (ซึ่งต่อไปนี้จะเรียกว่า{" "}
          <Text style={{ fontWeight: "bold" }}>“บัญชีรับเงินกู้”</Text>)
          ซึ่งมีรายละเอียดบัญชีรับเงินกู้ดังนี้&nbsp;&nbsp;&nbsp;
        </Text>
        <Text style={{ marginTop: "20px" }}>
          &nbsp;&nbsp;ชื่อบัญชี {data?.bankAccName}
        </Text>
        <Text style={{ marginTop: "20px" }}>
          &nbsp;&nbsp;เลขที่บัญชี {data?.bankNo}
        </Text>
        <Text style={{ marginTop: "20px" }}>
          &nbsp;&nbsp;ประเภทบัญชี ออมทรัพย์
        </Text>
        <Text style={{ marginTop: "20px" }}>
          &nbsp;&nbsp;ธนาคาร {data?.bank}
        </Text>
        <Text style={{ marginTop: "70px" }}>
          &nbsp;&nbsp;ทั้งนี้
          นอกจากการเบิกใช้สินเชื่อโดยการโอนเงินเข้าบัญชีรับเงินกู้แล้ว
          ผู้กู้ยังสามารถเบิกใช้สินเชื่อจากผู้ให้กู้ด้วย
        </Text>
        <Text>
          วิธีการอื่นใดตามที่ผู้ให้กู้และผู้กู้จะตกลงกัน (ถ้ามี) ตามเงื่อนไข
          รูปแบบ วิธีการและรายละเอียดที่ผู้ให้กู้ กำหนดและ&nbsp;
        </Text>
        <Text>
          เท่าที่กฎหมายอนุญาตให้ทำได้
          และเมื่อผู้ให้กู้ได้ดำเนินการดังกล่าวอนุญาตให้ทำได้และเมื่อผู้ให้กู้ได้ดำเนินการ&nbsp;&nbsp;&nbsp;&nbsp;
        </Text>
        <Text>
          ดังกล่าวตามที่ตกลงกันหรือกำหนดไว้แล้วให้ถือว่าผู้กู้ได้รับเงินสินเชื่อจากผู้ให้กู้ครบถ้วนถูกต้องแล้ว
          แม้ผู้กู้จะยัง&nbsp;&nbsp;
        </Text>
        <Text>
          ไม่ได้เบิกถอนเงินจากบัญชีรับเงินกู้หรือนำเงินที่ได้รับดังกล่าวไปใช้จ่ายก็ตาม
          โดยผู้กู้ไม่ต้องต้องทำหรือลงลายมือ&nbsp;&nbsp;
        </Text>
        <Text>
          ชื่อในเอกสารอื่นใดเพิ่มเติมเพื่อเป็นหลักฐานในการรับเงินอีก
          ทั้งนี้หลังจากที่ผู้ให้กู้ส่งมอบเงินสินเชื่อให้แก่ผู้กู้แล้ว&nbsp;&nbsp;
        </Text>
        <Text>
          ผู้ให้กู้จะแจ้งให้ผู้กู้ทราบผ่านทางระบบอิเล็กทรอนิกส์
          ทางไปรษณีย์อิเล็กทรอนิกส์ (E-mail) และ/หรือผ่านทาง
        </Text>
        <Text>เอกสารในรูปแบบกระดาษตามที่ผู้ให้กู้เห็นสมควร</Text>
        <Text style={{ marginTop: "20px", ...styleFinal.topic }}>
          &nbsp;&nbsp;2.2 เงื่อนไขบังคับก่อนสำหรับการเบิกใช้สินเชื่อ&nbsp;
        </Text>
        <Text style={{ marginTop: "20px" }}>
          &nbsp;&nbsp;&nbsp;ผู้กู้รับทราบและตกลงว่าผู้ให้กู้จะให้ผู้กู้เบิกใช้สินเชื่อได้ก็ต่อเมื่อผู้ให้กู้ได้รับเอกสารและหลักฐานต่างๆ
          ทั้งหมดดังต่อไปนี้จากผู้กู้
          ในรูปแบบและเนื้อหาที่ผู้ให้กู้เห็นสมควรแล้ว
          และผ่านระบบอิเล็กทรอนิกส์ของผู้ให้กู้
          หรือช่องทางอื่นใดที่ผู้ให้กู้กำหนด&nbsp;
        </Text>
        <Text style={{ marginTop: "20px" }}>
          &nbsp;&nbsp;(ก) เอกสารและหลักฐานในการยืนยันตัวตนของผู้กู้ และคู่สมรส
          (ถ้ามี) (รับรองสำเนาถูกต้องโดยเจ้าของเอกสาร)&nbsp;
        </Text>
        <Text style={{ marginTop: "20px" }}>
          &nbsp;&nbsp;(ข)
          ความยินยอมจากคู่สมรสของผู้กู้ในการเข้าทำและกู้ยืมเงินตามสัญญานี้
          (ถ้ามี)&nbsp;
        </Text>
        <Text style={{ marginTop: "20px" }}>
          &nbsp;&nbsp;(ค) สำเนาบัญชีรับเงินกู้ (รับรองสำเนาถูกต้องโดยผู้กู้
          และระบุข้อความที่แสดงว่าเป็นบัญชีรับเงินกู้สำหรับ&nbsp;&nbsp;&nbsp;
        </Text>
        <Text style={{ marginTop: "8px" }}>
          การรับเงินกู้ที่เบิกใช้ภายใต้วงเงินสินเชื่อของสัญญานี้)&nbsp;
        </Text>
        <Text style={{ marginTop: "20px" }}>
          &nbsp;&nbsp;(ง)
          เอกสารอื่นใดที่เป็นเงื่อนไขการเบิกใช้สินเชื่อตามที่ผู้ให้กู้อาจกำหนด
          (ถ้ามี)&nbsp;
        </Text>
        <Text style={{ marginTop: "20px", ...styleFinal.topic }}>
          &nbsp;&nbsp;2.3 เงื่อนไขบังคับก่อนเพิ่มเติมสำหรับการเบิกใช้สินเชื่อ
          (กรณีมีการค้ำประกันการชำระหนี้ของผู้กู้)&nbsp;&nbsp;&nbsp;&nbsp;
        </Text>
        <Text style={{ marginTop: "20px" }}>
          &nbsp;&nbsp;&nbsp;&nbsp;ภายใต้บังคับของเงื่อนไขอื่นๆ ในสัญญานี้
          ผู้ให้กู้จะให้ผู้กู้เบิกใช้สินเชื่อได้ก็ต่อเมื่อภายใน
          วันที่ผู้ให้กู้ออกหนังสือ
        </Text>
        <Text>
          ออกหนังสือยืนยันตามข้อ1 ข้างต้น ผู้กู้ต้องส่งมอบสัญญาค้ำประกันสินเชื่อ
          (ที่ลงนามครบถ้วนแล้ว) และเอกสาร&nbsp;
        </Text>
        <Text>
          ประกอบการทำสัญญาตามที่ระบุในสัญญาค้ำประกันสินเชื่อในรูปแบบและเนื้อหาที่ผู้ให้กู้ในรูปแบบและเนื้อหา&nbsp;&nbsp;
        </Text>
        <Text>
          ที่ผู้ให้กู้เห็นสมควร
          (กรณีมีการค้ำประกันการชำระหนี้ของผู้กู้)ให้กับผู้ให้กู้ผ่านระบบอิเล็กทรอนิกส์ของผู้ให้กู้หรือ&nbsp;&nbsp;&nbsp;&nbsp;
        </Text>
        <Text>ช่องทางอื่นใดที่ผู้ให้กู้กำหนด&nbsp;</Text>
        <Text style={{ marginTop: "20px", ...styleFinal.topic }}>
          &nbsp;&nbsp;2.4 หลักฐานแห่งหนี้
        </Text>
        <Text style={{ marginTop: "20px" }}>
          &nbsp;&nbsp;&nbsp;&nbsp;บรรดาบันทึกเอกสารหรือเอกสารใดๆ
          ที่ผู้ให้กู้ได้จัดทำขึ้นเพื่อการเบิกใช้สินเชื่อ
          การหักชำระค่าใช้จ่ายที่เกี่ยวข้อง&nbsp;&nbsp;
        </Text>
        <Text>
          และการโอนเงินกู้ให้แก่ผู้กู้ตามสัญญานี้
          ให้ถือว่าเป็นหลักฐานแห่งหนี้ตามสัญญานี้โดยถูกต้องและให้ถือว่าเอกสาร
        </Text>
        <Text>
          บันทึกหลักฐานดังกล่าว รวมทั้งข้อกำหนด และรายละเอียดเงื่อนไขต่างๆ
          ที่เกี่ยวข้องกับการดังกล่าวที่มีอยู่แล้ว และที่จะมีขึ้นต่อไปในภายหน้า
          เป็นส่วนหนึ่งแห่งสัญญานี้ด้วย&nbsp;
        </Text>
        <Text style={{ marginTop: "60px", ...styleFinal.topic }}>
          ข้อ 3. ดอกเบี้ยและอัตราดอกเบี้ย:
        </Text>
        <Text style={{ marginTop: "20px", ...styleFinal.topic }}>
          &nbsp;&nbsp;3.1 ดอกเบี้ย
        </Text>
        <Text style={{ marginTop: "20px" }}>
          &nbsp;&nbsp;(ก)
          ผู้กู้ตกลงเสียดอกเบี้ยในหนี้เงินต้นค้างชำระในแต่ละงวดให้แก่ผู้ให้กู้ในอัตรา
          33 % ต่อปี ทั้งนี้ ผู้ให้กู้อาจเปลี่ยน&nbsp;
        </Text>
        <Text>
          แปลงอัตราดอกเบี้ยดังกล่าวได้ตามที่ผู้ให้กู้จะประกาศกำหนดเป็นครั้งคราวและแจ้งให้ผู้กู้ทราบ
          และในการคำนวณ&nbsp;&nbsp;
        </Text>
        <Text>
          ดอกเบี้ยตามอัตราดังกล่าวจะเป็นไปตามวิธีการคิดดอกเบี้ยที่กฎหมายกำหนดหรืออนุญาตให้คิดได้และไม่เกินอัตรา&nbsp;&nbsp;
        </Text>
        <Text>
          สูงสุดตามกฎหมายที่อนุญาตให้ผู้ให้กู้เรียกได้
          และให้มีการคำนวณเป็นรายวัน โดยกำหนดให้หนึ่งปีเท่ากับ 365
          วัน&nbsp;&nbsp;
        </Text>
        <Text>ตามปฏิทิน&nbsp;&nbsp;</Text>
        <Text style={{ marginTop: "20px" }}>
          (ข) ในกรณีที่ผู้กู้ผิดนัด ไม่ปฏิบัติตามข้อกำหนดหรือเงื่อนไข
          และ/หรือไม่ชำระหนี้ใด ๆ ตามสัญญานี้หรือเอกสาร&nbsp;&nbsp;
        </Text>
        <Text>
          สินเชื่ออื่นใด
          ผู้กู้ตกลงและยินยอมว่าผู้ให้กู้อาจเรียกดอกเบี้ยในระหว่างเวลาผิดนัดชำระหนี้
          ค่าบริการต่าง ๆ เบี้ยปรับ และ/หรือค่าปรับในการชำระหนี้ล่าช้ากว่ากำหนด
          และ/หรือค่าธรรมเนียมใด ๆ
          ในอัตรารวมไม่เกินกว่าอัตราสูงสุด&nbsp;&nbsp;&nbsp;
        </Text>
        <Text>
          ผิดเงื่อนไข โดยคิดจากต้นเงินที่ค้างชำระของงวดที่ผิดนัด
          นับจากวันที่ผู้กู้ผิดนัดชำระหนี้ดังกล่าว จนถึงวันที่ผู้กู้&nbsp;&nbsp;
        </Text>
        <Text>ชำระหนี้ที่ผิดนัดดังกล่าวครบถ้วน&nbsp;&nbsp;</Text>
        <Text style={{ marginTop: "20px" }}>
          &nbsp;&nbsp;ทั้งนี้ “อัตราสูงสุดผิดเงื่อนไข” หมายความถึง
          อัตราดอกเบี้ยสูงสุดกรณีผิดนัดชำระหนี้ รวมถึง อัตราค่าบริการต่าง
          ๆ&nbsp;&nbsp;
        </Text>
        <Text>
          เบี้ยปรับ ค่าปรับในการชำระหนี้ล่าช้ากว่ากำหนด และค่าธรรมเนียมใด ๆ
          ที่ผู้ให้กู้ประกาศเรียกเก็บจากผู้กู้ที่เป็น&nbsp;&nbsp;
        </Text>
        <Text>
          ลูกค้าสินเชื่อของผู้ให้กู้
          ซึ่งอยู่ในกลุ่มและประเภทสินเชื่อเดียวกับผู้กู้ ปัจจุบันเท่ากับอัตรา
          33% ต่อปี ซึ่งอัตราดอกเบี้ย&nbsp;
        </Text>
        <Text>
          ดังกล่าวอาจเปลี่ยนแปลงได้ตามที่ผู้ให้กู้จะประกาศกำหนดเป็นครั้งคราวและแจ้งให้ผู้กู้ทราบ
          แต่ต้องไม่เกินกว่าอัตรา&nbsp;
        </Text>
        <Text>
          ดอกเบี้ยผิดนัดสูงสุดที่กฎหมายอนุญาตให้ผู้ให้กู้เรียกได้
          และให้มีการคำนวณเป็นรายวัน โดยกำหนดให้หนึ่งปีเท่ากับ&nbsp;&nbsp;
        </Text>
        <Text> 365 วันตามปฏิทิน&nbsp;&nbsp;</Text>
        <Text style={{ marginTop: "20px" }}>
          &nbsp;&nbsp;รายละเอียดและอัตราเรียกเก็บดอกเบี้ย เบี้ยปรับ ค่าปรับ
          ค่าบริการ ค่าธรรมเนียม และค่าใช้จ่ายใด ๆ ปรากฏตาม เอกสารแนบ ก.
        </Text>
        <Text style={{ marginTop: "20px" }}>
          &nbsp;&nbsp;3.2
          ในกรณีที่ผู้ให้กู้จะเปลี่ยนแปลงอัตราดอกเบี้ยใดตามสัญญานี้ผู้ให้กู้จะแจ้งให้ผู้กู้ทราบล่วงหน้า
          เป็นลายลักษณ์
        </Text>
        <Text>
          อักษร (ซึ่งจะต้องมีขนาดของตัวอักษรไม่เล็กกว่าสองมิลลิเมตร) โดย (1)
          หากเป็นกรณีทั่วไป จะแจ้งให้ผู้กู้ทราบล่วง
        </Text>
        <Text>
          หน้าเป็นระยะเวลาไม่น้อยกว่า 30 วัน และ (2) หากเป็นกรณีเร่งด่วน
          ผู้ให้กู้อาจจะแจ้งการเปลี่ยนแปลงทางจดหมาย (ซึ่งรวมถึงแต่ไม่จำกัดเพียง
          จดหมายที่ส่งให้ทางไปรษณีย์ ทางไปรษณีย์อิเล็กทรอนิกส์ (E-mail)
          และ/หรือช่องทาง&nbsp;
        </Text>
        <Text>
          อื่นใด) หรือประกาศทางหนังสือพิมพ์รายวัน
          ภาษาไทยที่แพร่หลายในประเทศล่วงหน้าเป็นระยะเวลาไม่น้อยกว่า 7
        </Text>
        <Text>
          วัน
          และกรณีที่แจ้งโดยประกาศทางหนังสือพิมพ์ผู้ให้กู้จะแจ้งการเปลี่ยนแปลงดังกล่าวเป็นลายลักษณ์อักษรไปยัง
        </Text>
        <Text>
          ผู้กู้ในภายหลังอีกครั้งและให้ถือว่าอัตราดอกเบี้ยที่มีการเปลี่ยนแปลงนั้นมีผลใช้บังคับตั้งแต่วันถัดจากวันที่ครบ
        </Text>
        <Text>กำหนดระยะเวลา ดังกล่าวข้างต้นเป็นต้นไป&nbsp;</Text>
        <Text style={{ marginTop: "20px", ...styleFinal.topic }}>
          ข้อ 4. การจ่ายชำระคืนหนี้เงินกู้ :
        </Text>
        <Text style={{ marginTop: "20px" }}>
          &nbsp;&nbsp;4.1 ผู้กู้ตกลงจะชำระคืนเงินกู้ที่ค้างชำระ เป็นรายเดือน
          เป็นจำนวนตามที่ระบุไว้ในหนังสือยืนยัน
          หรือเอกสารอันใด&nbsp;&nbsp;&nbsp;
        </Text>
        <Text>
          ตามที่ผู้ให้กู้เห็นสมควร และชำระทุกวันที่ {bankDate.getDate()}{" "}
          ของเดือน ทั้งนี้ ผู้กู้ตกลงและรับทราบว่าวันถึงกำหนดชำระงวดแรก
          อาจ&nbsp;&nbsp;
        </Text>
        <Text>
          มีระยะเวลามากกว่าหรือน้อยกว่า 30 วัน
          นับจากวันที่ผู้ให้กู้ได้ส่งมอบเงินกู้ให้แก่ผู้กู้
        </Text>
        <Text style={{ marginTop: "20px" }}>
          &nbsp;&nbsp;โดยวันชำระคืนเงินกู้งวดสุดท้ายคือ {getFullDate(endDate)}
        </Text>
        <Text style={{ marginTop: "20px" }}>
          &nbsp;&nbsp;4.2
          ผู้กู้ตกลงและรับทราบว่าการคำนวณดอกเบี้ยที่ผู้กู้ต้องผ่อนชำระให้แก่ผู้ให้กู้นั้นจะคำนวณโดยวิธีการคำนวณ&nbsp;&nbsp;&nbsp;&nbsp;
        </Text>
        <Text>
          แบบลดต้นลดดอกเช่นเดียวกับธรรมเนียมปฏิบัติโดยทั่วไปของสถาบันการเงิน
        </Text>
        <Text style={{ marginTop: "20px" }}>
          &nbsp;&nbsp;4.3
          ผู้กู้ตกลงนำเงินมาชำระหนี้ตามสัญญานี้ให้แก่ผู้ให้กู้ตามเงื่อนไขและรายละเอียดที่กำหนดไว้ในหนังสือยืนยัน&nbsp;&nbsp;&nbsp;
        </Text>
        <Text>
          โดยจะต้องชำระตามจำนวน กำหนดเวลาและวิธีการที่ระบุในใบแจ้งยอดรายการ
          (ตามแบบที่ผู้ให้กู้กำหนด) ที่ผู้ให้กู้ได้&nbsp;
        </Text>
        <Text>
          จัดส่งให้แก่ผู้กู้ในแต่ละเดือนทางช่องทางและรูปแบบของข้อมูลอิเล็กทรอนิกส์หรือรูปแบบอื่นใด
          ตามที่ผู้กู้กำหนด&nbsp;&nbsp;
        </Text>
        <Text>(ซึ่งต่อไปนี้จะเรียกว่า “ใบแจ้งยอดรายการ”)&nbsp;</Text>
        <Text style={{ marginTop: "20px" }}>
          &nbsp;&nbsp;4.4 ในกรณีที่ผู้กู้ขอชำระหนี้คืนก่อนกำหนด
          ผู้กู้จะต้องชำระดอกเบี้ยทั้งหมดที่ผู้กู้ค้างชำระอยู่กับผู้ให้กู้ ณ
          วันที่&nbsp;&nbsp;&nbsp;&nbsp;
        </Text>
        <Text>
          ผู้กู้ชำระคืนก่อนกำหนด ตลอดจนชำระค่าใช้จ่าย และเงินใด ๆ
          ที่ผู้กู้ค้างชำระอยู่กับผู้ให้กู้ (ถ้ามี)
          นอกจากนี้ใน&nbsp;&nbsp;&nbsp;&nbsp;
        </Text>
        <Text>
          กรณีที่เป็นการชำระหนี้คืนก่อนกำหนดบางส่วน
          ผู้กู้ตกลงยินยอมให้ผู้ให้กู้นำเงินที่ชำระนั้นไปหักชำระหนี้สินเชื่อ&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </Text>
        <Text>ที่ผู้กู้ต้องชำระในงวดถัดไปก่อน&nbsp;&nbsp;</Text>
        <Text style={{ marginTop: "25px", ...styleFinal.topic }}>
          ข้อ 5. ค่าธรรมเนียม ค่าปรับ ค่าใช้จ่ายต่าง ๆ
          หรือค่าใช้จ่ายใดตามสัญญานี้
        </Text>
        <Text style={{ marginTop: "20px" }}>
          &nbsp;&nbsp;5.1 ผู้กู้ตกลงชำระค่าอากรแสตมป์ ค่าธรรมเนียม ค่าปรับ
          ค่าบริการ ค่าใช้จ่ายที่เกิดขึ้นเนื่องจากการปฏิบัติตาม&nbsp;
        </Text>
        <Text>
          สัญญานี้และเอกสารสินเชื่ออื่น ๆ
          หรือเกี่ยวเนื่องกับการทำสัญญานี้และเอกสารสินเชื่ออื่น ๆ
          รวมทั้งค่าใช้จ่าย&nbsp;
        </Text>
        <Text>
          และค่าเสียหายที่เกิดขึ้นเนื่องจากการทวงถาม ดำเนินคดี ค่าทนายความ
          ค่าฤชาธรรมเนียมในการดำเนินคดี ตลอดจน&nbsp;&nbsp;
        </Text>
        <Text>
          การบังคับคดีและการบังคับชำระหนี้
          รายละเอียดและอัตราเรียกเก็บปรากฏตามเอกสารแนบ ก.
          (ซึ่งต่อไปนี้จะเรียกว่า “ค่าใช้จ่ายที่เกี่ยวข้อง”)
          โดยผู้กู้ยินยอมให้ผู้ให้กู้หักเงินจากสินเชื่อเพื่อนำไปชำระ
          ให้แก่ผู้ที่เกี่ยวข้องได้ทันที ทั้งนี้&nbsp;&nbsp;&nbsp;&nbsp;
        </Text>
        <Text>
          ตามวิธีปฏิบัติและภายในกำหนดเวลาที่ผู้ให้กู้กำหนด
          และให้ถือว่าการดำเนินการดังกล่าวเป็นการที่ผู้กู้ได้เบิกและรับ&nbsp;&nbsp;&nbsp;
        </Text>
        <Text>
          สินเชื่อตามจำนวนเงินที่ถูกหักดังกล่าวถูกต้องแล้ว
          ด้วยนอกจากนี้ผู้กู้ยินยอมให้ผู้ให้กู้มีสิทธิทดรองจ่ายเงินดังกล่าว&nbsp;&nbsp;
        </Text>
        <Text>
          แทนผู้กู้ไปก่อนได้ ในกรณีที่ผู้ให้กู้ได้ทดรองจ่ายเงินแทนผู้กู้ไปก่อน
          ผู้ให้กู้จะแจ้งให้ผู้กู้ทราบในใบแจ้งยอดรายการ&nbsp;&nbsp;
        </Text>
        <Text>
          และผู้กู้ตกลงชดใช้เงินตามจำนวนที่ผู้ให้กู้ได้จ่ายไปก่อนนั้นคืนให้แก่ผู้ให้กู้จนครบถ้วนภายในระยะเวลาที่กำหนด&nbsp;&nbsp;
        </Text>
        <Text>ไว้ในใบแจ้งยอดรายการ&nbsp;&nbsp;</Text>
        <Text style={{ marginTop: "20px" }}>
          &nbsp;&nbsp;5.2
          ในกรณีที่ผู้ให้กู้ตกลงเปลี่ยนแปลงอัตราค่าธรรมเนียมที่ใช้อยู่ขณะนี้ให้เพิ่มสูงขึ้น
          ผู้ให้กู้จะแจ้ง ให้ผู้กู้ทราบ
        </Text>
        <Text>
          ล่วงหน้าอย่างน้อย 30 วัน นอกจากนี้
          ผู้ให้กู้ขอสงวนสิทธิ์ในการคืนค่าธรรมเนียมที่ผู้กู้ชำระให้แก่ผู้ให้กู้แล้ว
          ทั้งนี้&nbsp;
        </Text>
        <Text>
          ในกรณีที่มีการเรียกเก็บค่าธรรมเนียมการชำระเงินดังกล่าว
          ผู้กู้มีหน้าที่ต้องชำระค่าธรรมเนียมดังกล่าวทั้งหลาย&nbsp;&nbsp;
        </Text>
        <Text>ตามอัตราและวิธีการที่ผู้ให้กู้กำหนด&nbsp;&nbsp;</Text>
        <Text style={{ marginTop: "20px", ...styleFinal.topic }}>
          ข้อ 6. คำรับรองและคำยืนยัน :
        </Text>
        <Text style={{ marginTop: "20px" }}>
          &nbsp;&nbsp;ตลอดระยะเวลาที่สัญญานี้มีผลใช้บังคับ
          ผู้กู้ขอให้คำรับรองและคำยืนยันตามที่ระบุไว้แก่ผู้ให้กู้ดังต่อไปนี้&nbsp;&nbsp;
        </Text>
        <Text style={{ marginTop: "20px" }}>
          &nbsp;&nbsp;6.1 ผู้กู้เป็นบุคคลธรรมดา มีความสามารถในการเข้าทำสัญญานี้
          มิได้เป็นคนวิกลจริต เสมือนไร้ความสามารถ หรือไร้ความสามารถ
          มิได้เป็นผู้มีหนี้สินล้นพ้นตัว
          มิได้ถูกศาลสั่งพิทักษ์ทรัพย์หรือถูกเจ้าพนักงานยึดหรืออายัดทรัพย์
          หรือมิได้เป็นบุคคลล้มละลาย โดยในวันที่ของสัญญานี้
          ผู้กู้มีสถานภาพทางการสมรส ดังนี้&nbsp;
        </Text>
        <Text style={{ marginTop: "50px" }}>
          &nbsp;&nbsp;{data?.marritalStatus == "โสด" ? "[x]" : "[ ]"}&nbsp; โสด
        </Text>
        <Text style={{ marginTop: "20px" }}>
          &nbsp;&nbsp;{data?.marritalStatus == "สมรส" ? "[x]" : "[ ]"}&nbsp;
          สมรสกับ{" "}
          {data?.marritalStatus == "โสด"
            ? "_________"
            : `${data?.articlePartner} ${data?.namePartner} ${data?.lastnamePartner}`}{" "}
          และได้รับความยินยอมจากคู่สมรสของผู้กู้ในการเข้าทำและกู้ยืมเงินตามสัญญานี้
          พร้อมทั้ง&nbsp;&nbsp;
        </Text>
        <Text>
          ได้ส่งมอบความยินยอมดังกล่าวจากคู่สมรสของผู้กู้ให้แก่ผู้ให้กู้แล้ว&nbsp;
        </Text>
        <Text style={{ marginTop: "20px" }}>
          &nbsp;&nbsp;6.2 การเข้าทำสัญญา การปฏิบัติตามสัญญา การจัดทำเอกสาร
          และการดำเนินการอื่นใดตามที่ระบุไว้ในสัญญานี้&nbsp;&nbsp;&nbsp;&nbsp;
        </Text>
        <Text>
          เป็นสิ่งที่อยู่ในอำนาจที่ผู้กู้สามารถกระทำได้
          และไม่เป็นการขัดต่อกฎหมายหรือข้อจำกัดตามสัญญาหรือข้อผูกพันใด ๆ
          ที่มีผลผูกพันต่อผู้กู้และผู้กู้ได้ดำเนินการตามที่จำเป็นเพื่ออนุมัติการเข้าทำ
          ปฏิบัติ
          และส่งมอบสัญญานี้แล้ว&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </Text>
        <Text style={{ marginTop: "20px" }}>
          &nbsp;&nbsp;6.3 ผู้กู้ได้รับอนุญาตและคำยินยอม
          สิทธิประโยชน์ใดๆหรือเอกสารอื่นใดจากส่วนราชการ หน่วยงาน และ/หรือ
          บุคคลอื่น
          ๆที่เกี่ยวข้องที่จำเป็นสำหรับการดำเนินการของผู้กู้และเกี่ยวกับการเข้าทำและการปฏิบัติตามสัญญานี้&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </Text>
        <Text style={{ marginTop: "20px" }}>
          &nbsp;&nbsp;6.4
          เมื่อผู้กู้ได้มีการยืนยันตอบรับข้อตกลงตามสัญญานี้ผ่านระบบอิเล็กทรอนิกส์ของผู้ให้กู้แล้วสัญญานี้เป็น
          สัญญาที่ชอบด้วยกฎหมายเป็นข้อผูกพันตามกฎหมายที่สมบูรณ์และมีผลผูกพันผู้กู้
          และสามารถที่จะใช้บังคับ
          กับผู้กู้ได้ตามข้อกำหนดที่ได้ระบุไว้ในสัญญานี้&nbsp;&nbsp;&nbsp;
        </Text>
        <Text style={{ marginTop: "20px" }}>
          &nbsp;&nbsp;6.5 การปฏิบัติตามข้อผูกพันใด ๆ ตามสัญญานี้ไม่และจะไม่
        </Text>
        <Text style={{ marginTop: "20px" }}>
          &nbsp;&nbsp;(ก) เป็นการฝ่าฝืน หรือขัดต่อข้อกำหนด เงื่อนไข คำรับรอง
          เอกสาร ตราสาร สัญญาข้อตกลง กฎหมาย หรือ&nbsp;&nbsp;
        </Text>
        <Text>ระเบียบข้อบังคับใดที่ผูกพันผู้กู้&nbsp;&nbsp;</Text>
        <Text style={{ marginTop: "20px" }}>
          &nbsp;&nbsp;(ข) เป็นการฝ่าฝืนข้อจำกัดใด ๆ ในเรื่องอำนาจการกู้ยืม
          หรือการก่อหนี้ หรือในเรื่องอำนาจอื่นใดของผู้กู้&nbsp;&nbsp;&nbsp;
        </Text>
        <Text style={{ marginTop: "20px" }}>
          &nbsp;&nbsp;6.6 นับจนถึงวันทำสัญญานี้ ไม่มีกระบวนการฟ้องร้อง ดำเนินคดี
          กระบวนการทางกฎหมายใด ๆ หรือกระบวนการ&nbsp;&nbsp;
        </Text>
        <Text>
          ทางอนุญาโตตุลาการ หรือการพิจารณาของหน่วยงานปกครอง ซึ่ง (ก)
          มีผลหรืออาจมีผลกระทบต่อความสามารถ&nbsp;&nbsp;
        </Text>
        <Text>
          ในการชำระหนี้ของผู้กู้ภายใต้สัญญานี้ และ/หรือ (ข)
          มีมูลคดีในการฟ้องร้องหรือดำเนินคดีดังกล่าวซึ่งค้างพิจารณา&nbsp;&nbsp;&nbsp;
        </Text>
        <Text>
          อยู่ในศาลหรือหน่วยงานใด ๆ ต่อผู้กู้
          และตราบเท่าที่ผู้กู้ทราบไม่มีผู้แสดงท่าทีว่าจะฟ้องร้องผู้กู้ทรัพย์สินหรือสิทธิใด
          ๆ
        </Text>
        <Text>
          ของผู้กู้ซึ่งจะมีผลกระทบเชิงลบต่อผู้กู้
          หรือความสามารถทางการเงินของผู้กู้ในการปฏิบัติตามสัญญานี้ หรือเอกสาร
        </Text>
        <Text>อื่นใดที่เกี่ยวข้อง</Text>
        <Text style={{ marginTop: "20px" }}>
          &nbsp;&nbsp;6.7 ผู้กู้มิได้ทำผิดหรือฝ่าฝืน หรือละเลยกฎหมาย
          หรือระเบียบข้อบังคับ คำสั่ง ข้อตกลง คำรับรอง ตราสาร
          สิทธิพิเศษ&nbsp;&nbsp;&nbsp;&nbsp;
        </Text>
        <Text>
          ใบอนุญาต หนังสืออนุญาต คำอนุญาต ข้อผูกพันหรือหน้าที่ใด
          ๆที่มีผลผูกพันผู้กู้หรือทรัพย์สินหรือรายรับใด ๆ ของ&nbsp;&nbsp;
        </Text>
        <Text>
          ผู้กู้โดยที่ผลของการผิด การฝ่าฝืน
          หรือการละเลยดังกล่าวอาจจะมีผลกระทบอย่างร้ายแรงต่อผู้กู้ ทรัพย์สิน
          หนี้หรือ&nbsp;&nbsp;
        </Text>
        <Text>
          สถานะ (ทางการเงิน หรืออื่น ๆ)&nbsp;
          ของผู้กู้หรือต่อความสามารถของผู้กู้ในเรื่องการปฏิบัติตามข้อผูกพันของผู้กู้ที่มีอยู่
        </Text>
        <Text>
          ตามสัญญานี้หรือเอกสารสินเชื่ออื่นใดที่เกี่ยวข้อง และไม่มีเหตุผิดนัดใด
          ๆ ได้เกิดขึ้น และยังคงดำรงอยู่ที่เกี่ยวข้อง&nbsp;&nbsp;
        </Text>
        <Text>กับสัญญานี้หรือเอกสารอื่นใด&nbsp;&nbsp;</Text>
        <Text style={{ marginTop: "20px" }}>
          &nbsp;&nbsp;6.8 ข้อมูลเกี่ยวกับผู้กู้และข้อมูลใด
          ๆที่ผู้กู้ได้ให้ไว้กับผู้ให้กู้เป็นข้อมูลที่เป็นความจริงถูกต้องและไม่ทำให้ผู้ให้กู้เข้าใจ&nbsp;
        </Text>
        <Text>ผิดในสาระสำคัญ&nbsp;&nbsp;</Text>
        <Text style={{ marginTop: "60px" }}>
          &nbsp;&nbsp;6.9 บรรดาข้อมูล เอกสาร หนังสือ
          และ/หรือหลักฐานอื่นใดที่เกี่ยวข้องที่ผู้กู้ส่งให้แก่ผู้ให้กู้ไม่ว่าผ่านทางช่องทางใด
        </Text>
        <Text>
          เป็นเอกสารของผู้กู้เองหรือเป็นเอกสารที่ผู้กู้ได้รับมาจากเจ้าของเอกสารและได้รับอนุญาตจากเจ้าของเอกสารให้นำส่งให้&nbsp;&nbsp;
        </Text>
        <Text>ผู้ให้กู้ได้&nbsp;&nbsp;</Text>
        <Text style={{ marginTop: "20px" }}>
          &nbsp;&nbsp;6.10
          สิทธิของผู้ให้กู้ที่มีต่อผู้กู้และทรัพย์สินของผู้กู้จะมีสิทธิเทียบเท่ากับเจ้าหนี้ที่ไม่มีประกันอื่นๆ
          ของผู้กู้
        </Text>
        <Text>เป็นอย่างน้อย ยกเว้นบุคคลที่มีบุริมสิทธิตามกฎหมาย</Text>
        <Text style={{ marginTop: "20px", ...styleFinal.topic }}>
          ข้อ 7. กรณีผิดนัด
        </Text>
        <Text style={{ marginTop: "20px" }}>
          &nbsp;&nbsp;ผู้กู้ตกลงว่า
          เมื่อเกิดกรณีใดกรณีหนึ่งดังจะกล่าวต่อไปนี้ให้ถือว่าผู้กู้เป็นผู้ผิดนัด
          ผิดสัญญา หรือผิดเงื่อนไข
        </Text>
        <Text>ตามสัญญานี้ :</Text>
        <Text style={{ marginTop: "20px" }}>
          &nbsp;&nbsp;7.1 เมื่อลูกหนี้รายใด ๆ ไม่ชำระหนี้สินเชื่อ
          ดอกเบี้ยค่าธรรมเนียม
          ค่าใช้จ่ายที่เกี่ยวข้องหรือเงินที่ลูกหนี้&nbsp;&nbsp;
        </Text>
        <Text>
          รายดังกล่าวมีหน้าที่ต้องชำระหนี้ตามเอกสารสินเชื่อ ตามจำนวน และ/หรือ
          ตามกำหนดเวลาที่ระบุไว้
        </Text>
        <Text>ในใบแจ้งยอดรายการ และ/หรือ เอกสารสินเชื่อ</Text>
        <Text style={{ marginTop: "20px" }}>
          &nbsp;&nbsp;7.2 เมื่อลูกหนี้รายใด ๆ
          ไม่ปฏิบัติหรือปฏิบัติผิดเงื่อนไขที่ระบุไว้ในเอกสารสินเชื่อหรือเอกสารอื่นตาม&nbsp;&nbsp;&nbsp;&nbsp;
        </Text>
        <Text>
          เอกสารสินเชื่อหรือเกี่ยวเนื่องกับเอกสารสินเชื่อ&nbsp;&nbsp;&nbsp;&nbsp;
        </Text>
        <Text style={{ marginTop: "20px" }}>
          &nbsp;&nbsp;7.3 เมื่อปรากฎว่า เอกสารหรือหลักฐานที่ลูกหนี้รายใด ๆ
          มอบให้แก่ผู้ให้กู้ มีข้อความเท็จ หรือเป็นเอกสารปลอม
          หรือไม่มีผลบังคับทางกฎหมาย
          ไม่ว่าทั้งหมดหรือแต่เพียงบางส่วน&nbsp;&nbsp;
        </Text>
        <Text style={{ marginTop: "20px" }}>
          &nbsp;&nbsp;7.4 เมื่อหนี้สินอื่นของลูกหนี้รายใด ๆ
          นอกเหนือจากที่ระบุไว้ในเอกสารสินเชื่อไม่มีการชำระเมื่อถึงกำหนด&nbsp;&nbsp;
        </Text>
        <Text>
          หรือเป็นอันต้องชำระก่อนถึงกำหนด หรือเจ้าหนี้ของลูกหนี้รายใด
          ๆมีสิทธิเรียกให้ ลูกหนี้รายดังกล่าวชำระหนี้&nbsp;&nbsp;&nbsp;&nbsp;
        </Text>
        <Text>ก่อนกำหนดตามเหตุอันสมควร&nbsp;&nbsp;</Text>
        <Text style={{ marginTop: "20px" }}>
          &nbsp;&nbsp;7.5 เมื่อลูกหนี้รายใด ๆ ถูกฟ้องร้องดำเนินคดี
          หรือเมื่อเกิดเหตุการณ์อื่นใดที่ผู้ให้กู้เห็นว่าการให้สินเชื่อแก่ผู้กู้&nbsp;&nbsp;
        </Text>
        <Text>
          อาจทำให้ผู้ให้กู้เสียหาย หรือลูกหนี้รายใด ๆ
          ไม่สามารถหรือน่าจะไม่สามารถชำระหนี้ให้ผู้ให้กู้ได้ครบถ้วน&nbsp;&nbsp;&nbsp;&nbsp;
        </Text>
        <Text style={{ marginTop: "20px" }}>
          &nbsp;&nbsp;7.6 เมื่อลูกหนี้รายใด ๆ ตกเป็นผู้มีหนี้สินล้นพ้นตัว
          หรือถูกศาลสั่งพิทักษ์ทรัพย์หรือถูกเจ้าพนักงานยึดหรืออายัด&nbsp;&nbsp;
        </Text>
        <Text>
          ทรัพย์หรือกระทำการใดอันอาจเป็นเหตุให้ถูกฟ้องล้มละลาย
          หรือถูกร้องขอให้ล้มละลายหรือกระทำการประนอมหนี้&nbsp;&nbsp;
        </Text>
        <Text>
          หรือถึงแก่ความตาย หรือตกเป็นผู้ไร้ความสามารถ
          หรือผู้เสมือนไร้ความสามารถ หรือเป็นผู้สาบสูญ หรือไปเสียจาก&nbsp;&nbsp;
        </Text>
        <Text>ถิ่นที่อยู่หาตัวไม่พบ&nbsp;&nbsp;</Text>
        <Text style={{ marginTop: "20px", ...styleFinal.topic }}>
          ข้อ 8. ผลของการผิดนัด
        </Text>
        <Text style={{ marginTop: "20px", textDecoration: "underline", textIndent: 8 }}>
          ผู้กู้ตกลงว่าในกรณีที่ผู้กู้ตกเป็นผู้ผิดนัด ผิดสัญญา
          หรือผิดเงื่อนไขดังที่กล่าวมาในข้อ 7
          ข้างต้นและผู้ให้กู้ได้แจ้ง&nbsp;&nbsp;
        </Text>
        <Text style={{ textDecoration: "underline" }}>
          เป็นลายลักษณ์อักษรไปยังผู้กู้เพื่อแก้ไขการผิดนัดผิดสัญญาหรือผิดเงื่อนไขดังกล่าวแล้ว
          แต่ผู้กู้ไม่ดำเนินการ&nbsp;&nbsp;
        </Text>
        <Text style={{ textDecoration: "underline" }}>
          หรือไม่สามารถดำเนินการแก้ไขให้แล้วเสร็จภายในระยะเวลาอันสมควรที่ผู้ให้กู้กำหนดไว้ให้ผู้ให้กู้มีสิทธิดำเนินการ&nbsp;&nbsp;&nbsp;
        </Text>
        <Text>ดังต่อไปนี้&nbsp;&nbsp;&nbsp;&nbsp;</Text>
        <Text style={{ marginTop: "40px", textDecoration: "underline", textIndent: 5 }}>
          (ก)
          ระงับการใช้วงเงินสินเชื่อทั้งหมดหรือบางส่วนไว้ชั่วคราวจนกว่าจะมีการแก้ไขกรณีผิดสัญญาหรือผิด
        </Text>
        <Text>เงื่อนไขดังกล่าว จนเป็นที่พอใจแก่ผู้ให้กู้ และ/หรือ</Text>
        <Text style={{ marginTop: "20px", textDecoration: "underline", textIndent: 5 }}>
          (ข) ยกเลิกวงเงินสินเชื่อที่เหลืออยู่ทั้งหมดหรือบางส่วน
          ซึ่งความผูกพันของผู้ให้กู้ในการให้วงเงินสินเชื่อ
          ดังกล่าวจะถูกยกเลิกโดยพลัน และ/หรือ
        </Text>
        <Text style={{ marginTop: "20px", textDecoration: "underline", textIndent: 5 }}>
          (ค) ให้ถือว่าเป็นการผิดนัดในจำนวนหนี้ทั้งหมด
          โดยให้บรรดาหนี้สินตามสัญญานี้และเอกสารสินเชื่ออื่น ๆ&nbsp;&nbsp;&nbsp;
        </Text>
        <Text style={{ textDecoration: "underline" }}>
          เป็นอันถึงกำหนดชำระ
          และผู้กู้ตกลงชำระหนี้สินค้างชำระทั้งหมดตามสัญญานี้และเอกสารสินเชื่ออื่นๆ
          ให้แก่&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </Text>
        <Text style={{ textDecoration: "underline" }}>
          ผู้ให้กู้ทันที
          รวมทั้งยินยอมชำระดอกเบี้ยผิดนัดในต้นเงินที่ค้างชำระทั้งหมดในอัตราสูงสุด
          จนกว่าจะชำระหนี้&nbsp;&nbsp;&nbsp;
        </Text>
        <Text style={{ textDecoration: "underline" }}>
          ทั้งหมดให้เสร็จสิ้น ตลอดจนยินยอมเสียค่าธรรมเนียม และ/หรือ ค่าบริการ
          และ/หรือ เงินอื่นใดที่ผู้กู้จะต้อง&nbsp;&nbsp;
        </Text>
        <Text style={{ textDecoration: "underline" }}>
          {" "}
          ชำระให้แก่ผู้ให้กู้ตามข้อกำหนดและเงื่อนไขของสัญญานี้
          (ถ้ามีและเท่าที่กฎหมายอนุญาตให้ผู้ให้กู้เรียกได้)&nbsp;&nbsp;
        </Text>
        <Text style={{ textDecoration: "underline" }}>
          ให้ครบถ้วนด้วย และ/หรือ&nbsp;&nbsp;
        </Text>
        <Text style={{ marginTop: "20px", textDecoration: "underline", textIndent: 5 }}>
          (ง) ใช้สิทธิในการบังคับตามเอกสารสินเชื่อต่าง ๆ
          ไม่ว่าส่วนใดส่วนหนึ่งหรือทั้งหมดได้&nbsp;&nbsp;
        </Text>
        <Text style={{ marginTop: "20px", ...styleFinal.topic }}>
          ข้อ 9. การติดต่อทวงถาม
        </Text>
        <Text style={{ marginTop: "20px" }}>
          &nbsp;&nbsp;ผู้กู้ตกลงเลือกรูปแบบการรับข้อมูลหรือเอกสารใด ๆ
          ตามสัญญานี้จากผู้ให้กู้ในรูปแบบ&nbsp;
        </Text>
        <Text style={{ marginTop: "20px" }}>
          &nbsp;&nbsp;{String(data?.letter) === "1" ? "[x]" : "[ ]"}
          &nbsp;รูปแบบข้อมูลอิเล็กทรอนิกส์ &nbsp;
        </Text>
        <Text style={{ marginTop: "20px" }}>
          &nbsp;&nbsp;{String(data?.letter) === "2" ? "[x]" : "[ ]"}
          &nbsp;รูปแบบกระดาษ
        </Text>
        <Text style={{ marginTop: "20px" }}>
          &nbsp;&nbsp;(หมายเหตุ: หากผู้กู้เลือกรูปแบบการรับข้อมูลหรือเอกสารใด ๆ
          ตามสัญญานี้ในรูปแบบกระดาษ จะไม่เป็นการตัด&nbsp;&nbsp;
        </Text>
        <Text>
          สิทธิผู้ให้กู้ในการดำเนินการส่งข้อมูลหรือเอกสารใด
          ๆตามสัญญานี้เพิ่มเติมใน รูปแบบข้อมูลอิเล็กทรอนิกส์ด้วย)&nbsp;&nbsp;
        </Text>
        <Text style={{ marginTop: "20px" }}>
          &nbsp;&nbsp;คำบอกกล่าว คำทวงถาม หรือการสื่อสารอื่นๆ
          แต่ละครั้งที่จะต้องส่งให้ หรือทำขึ้นตามสัญญานี้
          (ซึ่งรวมถึงแต่ไม่&nbsp;&nbsp;&nbsp;
        </Text>
        <Text>
          จำกัดเพียง ใบแจ้งหนี้หรือใบแจ้งยอดรายการ เป็นต้น) ให้ส่งให้
          หรือทำขึ้นผ่านทางระบบอิเล็กทรอนิกส์ของผู้ให้กู้&nbsp;&nbsp;
        </Text>
        <Text>
          และ/หรือทางไปรษณีย์อิเล็กทรอนิกส์ (E-mail)
          (ยกเว้นที่กำหนดไว้เป็นอย่างอื่นในสัญญานี้และเท่าที่กฎหมาย&nbsp;&nbsp;
        </Text>
        <Text>
          อนุญาตให้ทำได้) และผู้กู้ตกลงให้ผู้ให้กู้สามารถจัดทำ จัดเก็บ
          และจัดส่งข้อมูลรวมทั้งเอกสารที่ผู้ให้กู้ต้องเปิดเผย&nbsp;&nbsp;&nbsp;&nbsp;
        </Text>
        <Text>
          หรือแจ้งต่อผู้กู้ตามสัญญานี้และเอกสารสินเชื่ออื่น ๆ
          ในรูปแบบข้อมูลอิเล็กทรอนิกส์ (ยกเว้นที่กำหนดไว้เป็นอย่างอื่น&nbsp;
        </Text>
        <Text>ในสัญญานี้หรือกฎหมายกำหนดไว้เป็นอย่างอื่น)&nbsp;</Text>
        <Text style={{ marginTop: "10px" }}>
          &nbsp;&nbsp;ถ้าการติดต่อทวงถามหรือบอกกล่าวซึ่งตามกฎหมายหรือตามสัญญานี้ได้กำหนดหรือให้ต้องแจ้งหรือบอกกล่าวเป็นลาย
          ลักษณ์อักษร
          หากผู้ให้กู้ได้ส่งโดยทางไปรษณีย์ลงทะเบียนตอบรับไปยังที่อยู่ที่ระบุไว้ในรายการขอสินเชื่อทางระบบ
          อิเล็กทรอนิกส์ หรือที่ระบุไว้ในเอกสารสินเชื่อใด ๆ
          หรือส่งไปยังที่อยู่ที่ผู้กู้ได้แจ้งการย้ายหรือการเปลี่ยนแปลงเป็น&nbsp;&nbsp;&nbsp;
        </Text>
        <Text>
          ลายลักษณ์อักษรครั้งหลังสุดต่อผู้ให้กู้
          ให้ถือว่าได้ส่งให้แก่ผู้กู้แล้วโดยชอบ
        </Text>
        <Text style={{ marginTop: "80px", ...styleFinal.topic }}>
          ข้อ 10. การโอนสิทธิ และ/หรือ หน้าที่ตามสัญญานี้
        </Text>
        <Text style={{ marginTop: "20px" }}>
          &nbsp;&nbsp;ผู้กู้ตกลงยินยอมให้ผู้ให้กู้ โอนสิทธิ
          หน้าที่และ/หรือผลประโยชน์ตามสัญญานี้ไม่ว่าทั้งหมดหรือแต่บางส่วนให้แก่&nbsp;&nbsp;
        </Text>
        <Text>
          บุคคลผู้หนึ่งผู้ใดได้โดยผู้ให้กู้จะบอกกล่าวแจ้งการโอนเป็นลายลักษณ์อักษร
          ให้ผู้กู้ทราบล่วงหน้าเป็นระยะเวลา&nbsp;
        </Text>
        <Text>
          ไม่น้อยกว่าหนึ่งรอบงวดบัญชีโดยผู้ให้กู้ไม่จำเป็นต้องได้รับความยินยอมจากผู้กู้อีกแต่อย่างใด&nbsp;
        </Text>
        <Text style={{ marginTop: "20px", ...styleFinal.topic }}>
          ข้อ 11. การเป็นโมฆะ
        </Text>
        <Text style={{ marginTop: "20px" }}>
          &nbsp;&nbsp;ผู้กู้ตกลง
          หากข้อกำหนดหรือเงื่อนไขส่วนหนึ่งส่วนใดของสัญญานี้หรือเอกสารสัญญาที่เกี่ยวข้องหรือเกี่ยว
          เนื่องกับ&nbsp;&nbsp;
        </Text>
        <Text>
          สัญญานี้ใช้บังคับ ไม่ได้หรือเป็นโมฆะ หรือไม่สมบูรณ์
          หรือไม่ชอบด้วยกฎหมาย ให้มีผลเฉพาะข้อกำหนดหรือเงื่อนไข&nbsp;&nbsp;
        </Text>
        <Text>
          ในส่วนนั้นเท่านั้นโดยข้อกำหนดหรือเงื่อนไขในส่วนอื่นยังคงมีความสมบูรณ์และมีผลใช้บังคับ
          อยู่เช่นเดิมต่อไป และ&nbsp;
        </Text>
        <Text>
          ไม่เสื่อมเสียไป เพราะความเป็นโมฆะ ไม่สมบูรณ์ ไม่ชอบด้วยกฎหมาย
          หรือใช้บังคับมิได้ของข้อความหรือเอกสาร&nbsp;
        </Text>
        <Text>สัญญาที่เกี่ยวข้องฉบับดังกล่าว&nbsp;&nbsp;</Text>
        <Text style={{ marginTop: "20px", ...styleFinal.topic }}>
          ข้อ 12. การแก้ไขเงื่อนไขสินเชื่อ
        </Text>
        <Text style={{ marginTop: "20px" }}>
          &nbsp;&nbsp;ผู้กู้ตกลงยอมรับว่าผู้ให้กู้มีสิทธิทบทวน แก้ไข
          เปลี่ยนแปลงเพิ่มเติมเงื่อนไขหรือข้อกำหนดใดๆ เกี่ยวกับสินเชื่อ
          ไม่ว่า&nbsp;&nbsp;
        </Text>
        <Text>
          ตามสัญญานี้ หรือข้อตกลงอื่นใดได้ โดยในการดำเนินการดังกล่าว
          หากจะมีผลทำให้ผู้กู้เสียประโยชน์อย่างมีนัยสำคัญ&nbsp;&nbsp;&nbsp;&nbsp;
        </Text>
        <Text>
          ผู้ให้กู้จะแจ้งให้ผู้กู้ทราบล่วงหน้าอย่างน้อย 30
          วันก่อนการเปลี่ยนแปลงเพิ่มเติมดังกล่าวจะมีผลบังคับใช้&nbsp;&nbsp;&nbsp;&nbsp;
        </Text>
        <Text style={{ marginTop: "20px", ...styleFinal.topic }}>
          ข้อ 13. การไม่ใช้สิทธิที่มีอยู่ตามสัญญา
        </Text>
        <Text style={{ marginTop: "20px" }}>
          &nbsp;&nbsp;ผู้ในกรณีที่ผู้ให้กู้ละเลยไม่ใช้
          หรือล่าช้าต่อการใช้สิทธิทั้งหมดหรือแต่เพียงบางส่วนตามสัญญานี้ไม่ทำให้ผู้ให้กู้&nbsp;&nbsp;
        </Text>
        <Text>
          เสียสิทธิและ
          ไม่ถือว่าเป็นการสละสิทธิหรือการยินยอมให้ผู้กู้ไม่ปฎิบัติตามสัญญานี้
          รวมทั้งไม่ตัดสิทธิผู้ให้กู้ที่จะ&nbsp;&nbsp;
        </Text>
        <Text>
          ใช้สิทธิตามสัญญานี้ หรือสิทธิอื่น ๆ รวมถึงสิทธิตามกฎหมาย&nbsp;&nbsp;
        </Text>
        <Text style={{ marginTop: "20px", ...styleFinal.topic }}>
          ข้อ 14. เบ็ดเตล็ด
          และ/หรือรายละเอียดเงื่อนไขอื่นใดที่เกี่ยวกับสัญญาสินเชื่อ
        </Text>
        <Text style={{ marginTop: "20px" }}>
          &nbsp;&nbsp;14.1 ผู้กู้ตกลงยอมรับว่า การกำหนดดอกเบี้ย
          และ/หรือการทำข้อตกลงต่างๆ
          ตามสัญญานี้เป็นการดำเนินการ&nbsp;&nbsp;&nbsp;
        </Text>
        <Text>
          ตามหลักเกณฑ์และข้อกำหนดตามกฎหมาย
          และของหน่วยงานราชการที่ใช้อยู่ในขณะนี้
          ดังนั้นหากในภายหน้ามี&nbsp;&nbsp;
        </Text>
        <Text>
          การเปลี่ยนแปลงหลักเกณฑ์ และ/หรือ ข้อกำหนดดังกล่าวผู้กู้ตกลงยินยอม
          ให้ผู้ให้กู้มีสิทธิแก้ไขเปลี่ยนแปลง&nbsp;&nbsp;&nbsp;&nbsp;
        </Text>
        <Text>
          ดอกเบี้ยและ/หรือ
          ข้อตกลงตามสัญญานี้ได้ใหม่เพื่อให้เป็นไปตามหลักเกณฑ์และเงื่อนไขที่ได้มีการเปลี่ยนแปลง&nbsp;
        </Text>
        <Text>
          หรือเพิ่มเติมดังกล่าวโดยผู้ให้กู้จะปิดประกาศการกำหนด
          หรือแจ้งการเปลี่ยนแปลงดอกเบี้ย และ/หรือ ข้อตกลงไว้ ณ&nbsp;&nbsp;
        </Text>
        <Text>
          สำนักงานใหญ่และสาขา (ถ้ามี)
          ของผู้ให้กู้และผ่านทางช่องในระบบอิเล็กทรอนิกส์ของผู้ให้กู้รวมทั้งจะเผยแพร่&nbsp;&nbsp;
        </Text>
        <Text>
          ในเว็บไซต์ของผู้ให้กู้ เพื่อให้ผู้กู้ได้ทราบล่วงหน้าไม่น้อยกว่า 30 วัน
          ก่อนจะมีผลบังคับใช้ ทั้งนี้ เมื่อครบระยะเวลา&nbsp;
        </Text>
        <Text>
          ดังกล่าวแล้ว ผู้กู้ตกลงปฏิบัติตามหลักเกณฑ์ และ/หรือ
          ข้อกำหนดที่มีการเปลี่ยนแปลงใหม่นั้น&nbsp;&nbsp;
        </Text>
        <Text style={{ marginTop: "20px" }}>
          &nbsp;&nbsp;14.2 ผู้กู้ตกลงยอมรับว่า
          ในกรณีที่ผู้กู้สมัครหรือขอใช้บริการแจ้งเตือน
          หรือบริการอื่นใดของผู้ให้กู้ที่เกี่ยวข้อง&nbsp;&nbsp;
        </Text>
        <Text>
          กับสินเชื่อไม่ว่าจะได้มีการสมัครหรือขอใช้บริการแจ้งเตือนหรือบริการอื่นใดหรือไม่โดยผ่านช่องทาง
          การสมัคร&nbsp;
        </Text>
        <Text>
          หรือขอใช้บริการผ่านช่องทางการสมัครใดก็ตาม ทั้งนี้
          ไม่ว่าจะเป็นในรูปแบบอิเล็กทรอนิกส์หรือหลักฐานอื่นใด&nbsp;&nbsp;
        </Text>
        <Text>
          หรือการลงลายมือชื่อของผู้กู้
          หรือรูปแบบอื่นใดผู้กู้ตกลงยอมรับว่าจะปฏิบัติตามข้อกำหนดและเงื่อนไขการใช้
        </Text>
        <Text>
          บริการแจ้งเตือนหรือบริการอื่นใดดังกล่าวข้างต้นด้วย อนึ่ง
          ผู้กู้ได้อ่านทำความเข้าใจและอาจจะสั่งพิมพ์ออก (Print Out)
          ซึ่งข้อกำหนดและเงื่อนไขดังกล่าว
          จากเว็บไซต์ของผู้ให้กู้ก็ได้&nbsp;&nbsp;
        </Text>
        <Text style={{ marginTop: "20px" }}>
          &nbsp;&nbsp;14.3 รายละเอียดในเรื่องอื่นที่เกี่ยวกับการใช้สินเชื่อ
          นอกจากที่ได้กำหนดไว้ข้างต้นแล้ว ผู้กู้ตกลงปฏิบัติตาม&nbsp;&nbsp;
        </Text>
        <Text>
          ข้อกำหนด
          และเงื่อนไขที่จะมีการแก้ไขเพิ่มเติมตามที่ผู้ให้กู้จะได้แจ้งให้ทราบภายหน้า
          และหรือ เอกสารอื่นที่เกี่ยวข้อง
        </Text>
        <Text>
          กับสัญญานี้รวมทั้งข้อกำหนดและเงื่อนไขอื่นที่ผู้ให้กู้ประกาศกำหนดเป็นการทั่วไปทั้งนี้ไม่ว่าที่มีอยู่แล้วในขณะนี้&nbsp;&nbsp;
        </Text>
        <Text>และที่จะมีขึ้นในภายหน้าก็ตาม&nbsp;&nbsp;</Text>
        <Text style={{ marginTop: "20px" }}>
          &nbsp;&nbsp;14.4 บรรดาหลักฐาน เอกสาร หนังสือ และ/หรือ
          สัญญาอื่นที่เกี่ยวข้องกับสัญญานี้ และ/หรือ
          ที่ผู้กู้ทำให้ไว้แก่ผู้ให้กู้&nbsp;&nbsp;
        </Text>
        <Text>
          เพื่อเป็นการปฏิบัติตามวัตถุประสงค์ และ/หรือ เงื่อนไขของสัญญานี้
          ให้ถือเป็นส่วนหนึ่งของสัญญานี้ด้วย&nbsp;&nbsp;
        </Text>
        <Text style={{ marginTop: "20px" }}>
          &nbsp;&nbsp;14.5 สัญญานี้ และเอกสาร สิทธิและข้อผูกพันต่างๆ
          ของคู่สัญญาที่มีอยู่ตามสัญญานี้ ให้บังคับ ตีความ และแปล&nbsp;&nbsp;
        </Text>
        <Text>
          ความหมายตามกฎหมายไทยในทุกๆ ประการ
          ส่วนการฟ้องร้องบังคับคดีตามสัญญานี้ให้ดำเนินการ ณ
          ศาลแห่งราช&nbsp;&nbsp;
        </Text>
        <Text>
          อาณาจักรไทยตามเขตอำนาจศาลที่กำหนดไว้ในกฎหมาย&nbsp;&nbsp;&nbsp;&nbsp;
        </Text>
        <Text style={{ marginTop: "20px" }}>
          &nbsp;&nbsp;14.6 บรรดาหนังสือติดต่อทวงถาม
          หนังสือบอกกล่าวหรือหนังสืออื่นใดที่จะส่งให้แก่ผู้นั้น
          โดยการส่งทางไปรษณีย์&nbsp;&nbsp;
        </Text>
        <Text>
          ลงทะเบียนตอบรับ หากได้ส่งไปยังที่อยู่ของผู้กู้ที่ได้ระบุไว้ตามสัญญา
          หรือที่อยู่ที่ผู้กู้ได้แจ้งเปลี่ยนไว้เป็นหนังสือ&nbsp;&nbsp;
        </Text>
        <Text>
          หลังสุดให้ถือว่าบริษัทฯ ได้ส่งเอกสารดังกล่าวให้แก่ผู้กู้โดยชอบ
          ทั้งนี้โดยไม่คำนึงว่าจะมีผู้รับไว้หรือไม่ ให้ถือว่า&nbsp;&nbsp;
        </Text>
        <Text>
          ผู้กู้ได้รับและทราบหนังสือติดต่อทวงถาม บอกกล่าว
          หรือหนังสืออื่นใดของบริษัท แล้วโดยชอบ&nbsp;&nbsp;
        </Text>
        <Text style={{ marginTop: "20px" }}>
          &nbsp;&nbsp;14.7 กรณีผู้กู้ไม่สามารถติดต่อได้
          ทางบริษัทจะติดต่อไปยังบุคคลติดต่อฉุกเฉินทั้งสองท่านและในกรณีไม่สามารถ&nbsp;&nbsp;
        </Text>
        <Text>
          ติดต่อผู้กู้และบุคคลติดต่อฉุกเฉินมากกว่า 30 วัน
          ทางบริษัทจะใช้ข้อมูลสมุดโทรศัพท์ที่ผู้กู้ได้อนุญาตในแอพพลิเคชั่น
          สำหรับการติดต่อลำดับถัดไปโดยทางบริษัทจะขออนุญาตการสนทนากับปลายสายก่อนทุกครั้งและจะไม่มีการ&nbsp;&nbsp;
        </Text>
        <Text>
          แจ้งหนี้ใดๆ
          กับปลายสายดังกล่าวโดยบริษัทมีวัตถุประสงค์เพื่อเป็นการรักษาสิทธิและประโยชน์
          ของผู้กู้เองเท่านั้น&nbsp;&nbsp;
        </Text>
        <Text style={{ marginTop: "20px" }}>
          &nbsp;&nbsp;14.8
          กรณีลูกค้าชำระหนี้เกินยอดค่างวดที่ต้องชำระในแต่ละงวดหรือชำระหนี้เกินยอดหนี้ที่ต้องชำระในครั้งใดๆ&nbsp;&nbsp;&nbsp;&nbsp;
        </Text>
        <Text>
          ก็ดี
          หากลูกค้าประสงค์ขอรับเงินซึ่งชำระเกินมาคืนลูกค้าต้องติดต่อมายังบริษัทตามช่องทาง
          ที่บริษัทกำหนด&nbsp;&nbsp;
        </Text>
        <Text>
          เพื่อขอรับเงินคืนและยินยอมชำระค่าใช้จ่ายแก่บริษัทในการดำเนินการคืนเงินแก่ลูกค้าเป็นเงินจำนวน
          20 บาท&nbsp;&nbsp;&nbsp;&nbsp;
        </Text>
        <Text>
          รวมตลอดถึงค่าธรรมเนียมต่างๆที่เกิดขึ้นแก่บริษัทอันเนื่องมาจาก
          การคืนเงินแก่ลูกค้าด้วย&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </Text>
        <Text
          style={{
            // marginTop: "250px",
            marginTop: "200px",
            ...styleFinal.topic,
            textAlign: "center",
            fontSize: "16px",
          }}
        >
          เอกสารแนบ ก.
        </Text>
        <Text style={{ marginTop: "20px", textAlign: "center" }}>
          ชื่อผู้ให้กู้ บริษัท มันนี่ ฮับ เซอร์วิส จำกัด&nbsp;&nbsp;
        </Text>
        <Text style={{ marginTop: "20px", textAlign: "center" }}>
          รายละเอียดเกี่ยวกับอัตราดอกเบี้ย เบี้ยปรับ ค่าปรับ ค่าบริการ
          ค่าธรรมเนียมใด ๆ&nbsp;&nbsp;
        </Text>
        <Text style={{ marginTop: "20px", textAlign: "center" }}>
          และค่าใช้จ่ายใด ๆ
          [ตามที่ได้จ่ายจริงและพอสมควรแก่เหตุเกี่ยวกับสินเชื่อส่วนบุคคลภายใต้การกำกับที่มิใช่สินเชื่อที่มีทะเบียนรถเป็นประกัน]
        </Text>
        <Text style={{ textAlign: "center" }}>
          /[ที่ผู้ประกอบธุรกิจอาจเรียกได้ในการประกอบธุรกิจสินเชื่อรายย่อยเพื่อการประกอบอาชีพภายใต้การกำกับ&nbsp;&nbsp;
        </Text>
        <Text style={{ marginTop: "20px", textAlign: "center" }}>
          เริ่มใช้ตั้งแต่วันที่ {getFullDate(completeDate)}
        </Text>
        <Text style={{ marginTop: "20px", ...styleFinal.topic }}>
          (1) อัตราดอกเบี้ยแบบลดต้นลดดอก
        </Text>
        <Text style={{ marginTop: "20px" }}>
          &nbsp;&nbsp;ดอกเบี้ยร้อยละ 33 ต่อปี กรณีสินเชื่อเพื่อการประกอบอาชีพ
          (Effective rate)
        </Text>
        <Text>
          &nbsp;&nbsp;ดอกเบี้ยร้อยละ 25 ต่อปี กรณีสินเชื่อเพื่ออุปโภค บริโภค
          และการท่องเที่ยว (Effective rate)
          และไม่เกินกว่าอัตราดอกเบี้ยสูงสุดกรณีปกติสำหรับสินเชื่อนี้ รวมทั้ง
          เมื่อคำนวณดอกเบี้ย เบี้ยปรับ ค่าปรับ ค่าบริการ&nbsp;&nbsp;
        </Text>
        <Text>ค่าธรรมเนียมใดๆ และค่าใช้จ่ายอื่นๆรวมกัน&nbsp;&nbsp;</Text>
        <Text style={{ marginTop: "20px", ...styleFinal.topic }}>
          (2) การคำนวณดอกเบี้ยและค่าธรรมเนียมการใช้วงเงิน
        </Text>

        <Text style={{ marginTop: "20px" }}>
          <Text style={{ fontFamily: "NotoSansSymbols2" }}>
            {" "}
            &nbsp;&nbsp; &#10004;
          </Text>{" "}
          การคำนวณดอกเบี้ย : รายวัน&nbsp;&nbsp;
        </Text>
        <Text style={{ marginTop: "20px" }}>
          <Text style={{ fontFamily: "NotoSansSymbols2" }}>
            {" "}
            &nbsp;&nbsp; &#10004;
          </Text>{" "}
          จำนวนวันต่อปีที่ใช้ในการคำนวณดอกเบี้ย : 365 วัน&nbsp;&nbsp;
        </Text>
        <Text style={{ marginTop: "20px" }}>
          <Text style={{ fontFamily: "NotoSansSymbols2" }}>
            {" "}
            &nbsp;&nbsp; &#10004;
          </Text>{" "}
          อัตราค่าธรรมเนียมการใช้วงเงิน : ไม่มีค่าธรรมเนียม&nbsp;&nbsp;
        </Text>
        <Text style={{ marginTop: "20px", ...styleFinal.topic }}>
          (3) ค่าธรรมเนียมและค่าบริการ
        </Text>
        <Text style={{ marginTop: "20px" }}>
          <Text style={{ fontFamily: "NotoSansSymbols2" }}>
            {" "}
            &nbsp;&nbsp; &#10004;
          </Text>{" "}
          ค่าอากรแสตมป์ : ไม่มีเรียกเก็บค่าอากรแสตมป์&nbsp;&nbsp;
        </Text>
        <Text style={{ marginTop: "20px" }}>
          <Text style={{ fontFamily: "NotoSansSymbols2" }}>
            {" "}
            &nbsp;&nbsp; &#10004;
          </Text>{" "}
          ค่าใช้จ่ายในตรวจสอบข้อมูลเครดิต : ไม่มีเรียกเก็บ&nbsp;&nbsp;
        </Text>
        <Text style={{ marginTop: "20px" }}>
          <Text style={{ fontFamily: "NotoSansSymbols2" }}>
            {" "}
            &nbsp;&nbsp; &#10004;
          </Text>{" "}
          ค่าติดตามทวงถามหนี้ :
          มีการเรียกเก็บแล้วแต่กรณีไม่เกินที่กฎหมายกำหนด&nbsp;&nbsp;
        </Text>
        <Text style={{ marginTop: "20px" }}>
          <Text style={{ fontFamily: "NotoSansSymbols2" }}>
            {" "}
            &nbsp;&nbsp; &#10004;
          </Text>{" "}
          ค่าธรรมเนียมชำระเงิน ผ่านช่องทางผู้ให้บริการรายอื่น :
          ขึ้นอยู่กับผู้ให้บริการรายนั้น ๆ&nbsp;&nbsp;
        </Text>
        <Text style={{ marginTop: "20px" }}>
          <Text style={{ fontFamily: "NotoSansSymbols2" }}>
            {" "}
            &nbsp;&nbsp; &#10004;
          </Text>{" "}
          Bill Payment : QR Code พร้อมเพย์ : ไม่มีค่าธรรมเนียม&nbsp;&nbsp;
        </Text>
        <Text style={{ marginTop: "20px" }}>
          (หมายเหตุ : อัตราค่าธรรมเนียมอาจมีการเปลี่ยนแปลงได้
          ซึ่งเป็นไปตามประกาศของบริษัทฯ ซึ่งสามารถตรวจสอบได้ผ่านเว็บไซต์
          www.moneyhubservice.com)
        </Text>
        <Text
          style={{
            marginTop: "20px",
            textAlign: "right",
            fontWeight: "bold",
          }}
        >
          ข้าพเจ้า {data?.article} {data?.name} {data?.lastname}
        </Text>
        <Text
          style={{
            marginTop: "20px",
            textAlign: "right",
            fontWeight: "bold",
          }}
        >
          (ผู้กู้/ผู้รับผลประโยชน์)
        </Text>
        <Text
          style={{
            marginTop: "20px",
            textAlign: "right",
            fontWeight: "bold",
          }}
        >
          เบอร์โทร {data?.phone_number}
        </Text>
        <Text
          style={{
            marginTop: "20px",
            textAlign: "right",
            fontWeight: "bold",
          }}
        >
          ยืนยันด้วยระบบอิเล็กทรอนิกส์ว่าข้อมูลของข้าพเจ้าถูกต้องและเป็นความจริงทุกประการ
        </Text>
        <Text
          style={{
            marginTop: "20px",
            textAlign: "right",
            fontWeight: "bold",
          }}
        >
          วันที่ {getFullDate(today, { showMonth: true })}
        </Text>
      </Page>
    </Document>
  );
  {
    /* </PDFViewer> */
  }
}

export default GenFinalPdf;
